// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AccessReviewInventoryData,
  AccessReviewInventoryErrors,
  AccessReviewInventoryResponses,
  ApiKeyCreateData,
  ApiKeyCreateErrors,
  ApiKeyCreateResponses,
  ApiKeyListByOrgData,
  ApiKeyListByOrgErrors,
  ApiKeyListByOrgResponses,
  ApiKeyListByProjectData,
  ApiKeyListByProjectErrors,
  ApiKeyListByProjectResponses,
  ApiKeyListByServiceAccountData,
  ApiKeyListByServiceAccountErrors,
  ApiKeyListByServiceAccountResponses,
  ApiKeyListByUserData,
  ApiKeyListByUserErrors,
  ApiKeyListByUserResponses,
  ApiKeyRevokeData,
  ApiKeyRevokeErrors,
  ApiKeyRevokeResponses,
  ApiKeyRotateData,
  ApiKeyRotateErrors,
  ApiKeyRotateResponses,
  ApiV1AudioSpeechData,
  ApiV1AudioSpeechErrors,
  ApiV1AudioSpeechResponses,
  ApiV1AudioTranscriptionsData,
  ApiV1AudioTranscriptionsErrors,
  ApiV1AudioTranscriptionsResponses,
  ApiV1AudioTranslationsData,
  ApiV1AudioTranslationsErrors,
  ApiV1AudioTranslationsResponses,
  ApiV1ChatCompletionsData,
  ApiV1ChatCompletionsErrors,
  ApiV1ChatCompletionsResponses,
  ApiV1CompletionsData,
  ApiV1CompletionsErrors,
  ApiV1CompletionsResponses,
  ApiV1ContainersCreateData,
  ApiV1ContainersCreateErrors,
  ApiV1ContainersCreateResponses,
  ApiV1ContainersDeleteData,
  ApiV1ContainersDeleteErrors,
  ApiV1ContainersDeleteResponses,
  ApiV1ContainersFileContentData,
  ApiV1ContainersFileContentErrors,
  ApiV1ContainersFileContentResponses,
  ApiV1ContainersFileDeleteData,
  ApiV1ContainersFileDeleteErrors,
  ApiV1ContainersFileDeleteResponses,
  ApiV1ContainersFileGetData,
  ApiV1ContainersFileGetErrors,
  ApiV1ContainersFileGetResponses,
  ApiV1ContainersFileUploadData,
  ApiV1ContainersFileUploadErrors,
  ApiV1ContainersFileUploadResponses,
  ApiV1ContainersGetData,
  ApiV1ContainersGetErrors,
  ApiV1ContainersGetResponses,
  ApiV1ContainersListData,
  ApiV1ContainersListErrors,
  ApiV1ContainersListFilesData,
  ApiV1ContainersListFilesErrors,
  ApiV1ContainersListFilesResponses,
  ApiV1ContainersListResponses,
  ApiV1EmbeddingsData,
  ApiV1EmbeddingsErrors,
  ApiV1EmbeddingsResponses,
  ApiV1ImagesEditsData,
  ApiV1ImagesEditsErrors,
  ApiV1ImagesEditsResponses,
  ApiV1ImagesGenerationsData,
  ApiV1ImagesGenerationsErrors,
  ApiV1ImagesGenerationsResponses,
  ApiV1ImagesVariationsData,
  ApiV1ImagesVariationsErrors,
  ApiV1ImagesVariationsResponses,
  ApiV1ModelsData,
  ApiV1ModelsErrors,
  ApiV1ModelsResponses,
  ApiV1ResponsesCancelData,
  ApiV1ResponsesCancelErrors,
  ApiV1ResponsesCancelResponses,
  ApiV1ResponsesCompactData,
  ApiV1ResponsesCompactErrors,
  ApiV1ResponsesCompactResponses,
  ApiV1ResponsesData,
  ApiV1ResponsesDeleteData,
  ApiV1ResponsesDeleteErrors,
  ApiV1ResponsesDeleteResponses,
  ApiV1ResponsesErrors,
  ApiV1ResponsesGetData,
  ApiV1ResponsesGetErrors,
  ApiV1ResponsesGetResponses,
  ApiV1ResponsesResponses,
  ApiV1VideosCharactersCreateData,
  ApiV1VideosCharactersCreateResponses,
  ApiV1VideosCharactersRetrieveData,
  ApiV1VideosCharactersRetrieveResponses,
  ApiV1VideosContentData,
  ApiV1VideosContentResponses,
  ApiV1VideosCreateData,
  ApiV1VideosCreateErrors,
  ApiV1VideosCreateResponses,
  ApiV1VideosDeleteData,
  ApiV1VideosDeleteResponses,
  ApiV1VideosEditsData,
  ApiV1VideosEditsResponses,
  ApiV1VideosExtensionsData,
  ApiV1VideosExtensionsResponses,
  ApiV1VideosListData,
  ApiV1VideosListResponses,
  ApiV1VideosRemixData,
  ApiV1VideosRemixResponses,
  ApiV1VideosRetrieveData,
  ApiV1VideosRetrieveErrors,
  ApiV1VideosRetrieveResponses,
  AuditLogGetData,
  AuditLogGetErrors,
  AuditLogGetResponses,
  AuditLogListData,
  AuditLogListErrors,
  AuditLogListResponses,
  AuthDiscoverData,
  AuthDiscoverErrors,
  AuthDiscoverResponses,
  AuthMeData,
  AuthMeErrors,
  AuthMeResponses,
  ConversationAppendMessagesData,
  ConversationAppendMessagesErrors,
  ConversationAppendMessagesResponses,
  ConversationCreateData,
  ConversationCreateErrors,
  ConversationCreateResponses,
  ConversationDeleteData,
  ConversationDeleteErrors,
  ConversationDeleteResponses,
  ConversationGetData,
  ConversationGetErrors,
  ConversationGetResponses,
  ConversationListAccessibleForUserData,
  ConversationListAccessibleForUserErrors,
  ConversationListAccessibleForUserResponses,
  ConversationListByProjectData,
  ConversationListByProjectErrors,
  ConversationListByProjectResponses,
  ConversationListByUserData,
  ConversationListByUserErrors,
  ConversationListByUserResponses,
  ConversationSetPinData,
  ConversationSetPinErrors,
  ConversationSetPinResponses,
  ConversationUpdateData,
  ConversationUpdateErrors,
  ConversationUpdateResponses,
  DlqDeleteData,
  DlqDeleteErrors,
  DlqDeleteResponses,
  DlqGetData,
  DlqGetErrors,
  DlqGetResponses,
  DlqListData,
  DlqListErrors,
  DlqListResponses,
  DlqPruneData,
  DlqPruneErrors,
  DlqPruneResponses,
  DlqPurgeData,
  DlqPurgeErrors,
  DlqPurgeResponses,
  DlqRetryData,
  DlqRetryErrors,
  DlqRetryResponses,
  DlqStatsData,
  DlqStatsErrors,
  DlqStatsResponses,
  DomainVerificationsCreateData,
  DomainVerificationsCreateErrors,
  DomainVerificationsCreateResponses,
  DomainVerificationsDeleteData,
  DomainVerificationsDeleteErrors,
  DomainVerificationsDeleteResponses,
  DomainVerificationsGetData,
  DomainVerificationsGetErrors,
  DomainVerificationsGetInstructionsData,
  DomainVerificationsGetInstructionsErrors,
  DomainVerificationsGetInstructionsResponses,
  DomainVerificationsGetResponses,
  DomainVerificationsListData,
  DomainVerificationsListErrors,
  DomainVerificationsListResponses,
  DomainVerificationsVerifyData,
  DomainVerificationsVerifyErrors,
  DomainVerificationsVerifyResponses,
  DynamicProviderCreateData,
  DynamicProviderCreateErrors,
  DynamicProviderCreateResponses,
  DynamicProviderDeleteData,
  DynamicProviderDeleteErrors,
  DynamicProviderDeleteResponses,
  DynamicProviderGetData,
  DynamicProviderGetErrors,
  DynamicProviderGetResponses,
  DynamicProviderListByOrgData,
  DynamicProviderListByOrgErrors,
  DynamicProviderListByOrgResponses,
  DynamicProviderListByProjectData,
  DynamicProviderListByProjectErrors,
  DynamicProviderListByProjectResponses,
  DynamicProviderListByUserData,
  DynamicProviderListByUserErrors,
  DynamicProviderListByUserResponses,
  DynamicProviderTestCredentialsData,
  DynamicProviderTestCredentialsErrors,
  DynamicProviderTestCredentialsResponses,
  DynamicProviderTestData,
  DynamicProviderTestErrors,
  DynamicProviderTestResponses,
  DynamicProviderUpdateData,
  DynamicProviderUpdateErrors,
  DynamicProviderUpdateResponses,
  FileDeleteData,
  FileDeleteErrors,
  FileDeleteResponses,
  FileGetContentData,
  FileGetContentErrors,
  FileGetContentResponses,
  FileGetData,
  FileGetErrors,
  FileGetResponses,
  FileListData,
  FileListErrors,
  FileListResponses,
  FileUploadData,
  FileUploadErrors,
  FileUploadResponses,
  GetCircuitBreakerData,
  GetCircuitBreakerErrors,
  GetCircuitBreakerResponses,
  GetProviderHealthData,
  GetProviderHealthErrors,
  GetProviderHealthResponses,
  GetProviderStatsData,
  GetProviderStatsErrors,
  GetProviderStatsHistoryData,
  GetProviderStatsHistoryErrors,
  GetProviderStatsHistoryResponses,
  GetProviderStatsResponses,
  HealthCheckData,
  HealthCheckErrors,
  HealthCheckResponses,
  HealthLivenessData,
  HealthLivenessResponses,
  HealthReadinessData,
  HealthReadinessErrors,
  HealthReadinessResponses,
  ListCircuitBreakersData,
  ListCircuitBreakersResponses,
  ListProviderHealthData,
  ListProviderHealthResponses,
  ListProviderStatsData,
  ListProviderStatsErrors,
  ListProviderStatsResponses,
  MeApiKeysCreateData,
  MeApiKeysCreateErrors,
  MeApiKeysCreateResponses,
  MeApiKeysGetData,
  MeApiKeysGetErrors,
  MeApiKeysGetResponses,
  MeApiKeysListData,
  MeApiKeysListErrors,
  MeApiKeysListResponses,
  MeApiKeysRevokeData,
  MeApiKeysRevokeErrors,
  MeApiKeysRevokeResponses,
  MeApiKeysRotateData,
  MeApiKeysRotateErrors,
  MeApiKeysRotateResponses,
  MeBuiltInProvidersListData,
  MeBuiltInProvidersListResponses,
  MeDeleteData,
  MeDeleteErrors,
  MeDeleteResponses,
  MeEligibleOwnersData,
  MeEligibleOwnersErrors,
  MeEligibleOwnersResponses,
  MeExportData,
  MeExportErrors,
  MeExportResponses,
  MeProvidersCreateData,
  MeProvidersCreateErrors,
  MeProvidersCreateResponses,
  MeProvidersDeleteData,
  MeProvidersDeleteErrors,
  MeProvidersDeleteResponses,
  MeProvidersGetData,
  MeProvidersGetErrors,
  MeProvidersGetResponses,
  MeProvidersListData,
  MeProvidersListErrors,
  MeProvidersListResponses,
  MeProvidersTestCredentialsData,
  MeProvidersTestCredentialsErrors,
  MeProvidersTestCredentialsResponses,
  MeProvidersTestData,
  MeProvidersTestErrors,
  MeProvidersTestResponses,
  MeProvidersUpdateData,
  MeProvidersUpdateErrors,
  MeProvidersUpdateResponses,
  MeSessionsDeleteOneData,
  MeSessionsDeleteOneErrors,
  MeSessionsDeleteOneResponses,
  MeSessionsListData,
  MeSessionsListErrors,
  MeSessionsListResponses,
  MeUsageByDateData,
  MeUsageByDateErrors,
  MeUsageByDateModelData,
  MeUsageByDateModelResponses,
  MeUsageByDatePricingSourceData,
  MeUsageByDatePricingSourceResponses,
  MeUsageByDateProviderData,
  MeUsageByDateProviderResponses,
  MeUsageByDateResponses,
  MeUsageByModelData,
  MeUsageByModelErrors,
  MeUsageByModelResponses,
  MeUsageByPricingSourceData,
  MeUsageByPricingSourceResponses,
  MeUsageByProviderData,
  MeUsageByProviderErrors,
  MeUsageByProviderResponses,
  MeUsageLogExportData,
  MeUsageLogExportResponses,
  MeUsageLogListData,
  MeUsageLogListResponses,
  MeUsageSummaryData,
  MeUsageSummaryErrors,
  MeUsageSummaryResponses,
  ModelPricingBulkUpsertData,
  ModelPricingBulkUpsertResponses,
  ModelPricingCreateData,
  ModelPricingCreateErrors,
  ModelPricingCreateResponses,
  ModelPricingDeleteData,
  ModelPricingDeleteErrors,
  ModelPricingDeleteResponses,
  ModelPricingGetData,
  ModelPricingGetErrors,
  ModelPricingGetResponses,
  ModelPricingListByOrgData,
  ModelPricingListByOrgErrors,
  ModelPricingListByOrgResponses,
  ModelPricingListByProjectData,
  ModelPricingListByProjectErrors,
  ModelPricingListByProjectResponses,
  ModelPricingListByProviderData,
  ModelPricingListByProviderErrors,
  ModelPricingListByProviderResponses,
  ModelPricingListByUserData,
  ModelPricingListByUserErrors,
  ModelPricingListByUserResponses,
  ModelPricingListGlobalData,
  ModelPricingListGlobalErrors,
  ModelPricingListGlobalResponses,
  ModelPricingUpdateData,
  ModelPricingUpdateErrors,
  ModelPricingUpdateResponses,
  ModelPricingUpsertData,
  ModelPricingUpsertResponses,
  OauthAuthorizationServerMetadataData,
  OauthAuthorizationServerMetadataErrors,
  OauthAuthorizationServerMetadataResponses,
  OauthAuthorizeData,
  OauthAuthorizeErrors,
  OauthAuthorizeResponses,
  OauthPreflightData,
  OauthPreflightErrors,
  OauthPreflightResponses,
  OauthTokenData,
  OauthTokenErrors,
  OauthTokenResponses,
  OrgAccessReportData,
  OrgAccessReportErrors,
  OrgAccessReportResponses,
  OrganizationCreateData,
  OrganizationCreateErrors,
  OrganizationCreateResponses,
  OrganizationDeleteData,
  OrganizationDeleteErrors,
  OrganizationDeleteResponses,
  OrganizationGetData,
  OrganizationGetErrors,
  OrganizationGetResponses,
  OrganizationListData,
  OrganizationListErrors,
  OrganizationListResponses,
  OrganizationUpdateData,
  OrganizationUpdateErrors,
  OrganizationUpdateResponses,
  OrgMemberAddData,
  OrgMemberAddErrors,
  OrgMemberAddResponses,
  OrgMemberListData,
  OrgMemberListErrors,
  OrgMemberListResponses,
  OrgMemberRemoveData,
  OrgMemberRemoveErrors,
  OrgMemberRemoveResponses,
  OrgRbacPolicyCreateData,
  OrgRbacPolicyCreateErrors,
  OrgRbacPolicyCreateResponses,
  OrgRbacPolicyDeleteData,
  OrgRbacPolicyDeleteErrors,
  OrgRbacPolicyDeleteResponses,
  OrgRbacPolicyGetData,
  OrgRbacPolicyGetErrors,
  OrgRbacPolicyGetResponses,
  OrgRbacPolicyListData,
  OrgRbacPolicyListErrors,
  OrgRbacPolicyListResponses,
  OrgRbacPolicyListVersionsData,
  OrgRbacPolicyListVersionsErrors,
  OrgRbacPolicyListVersionsResponses,
  OrgRbacPolicyRollbackData,
  OrgRbacPolicyRollbackErrors,
  OrgRbacPolicyRollbackResponses,
  OrgRbacPolicySimulateData,
  OrgRbacPolicySimulateErrors,
  OrgRbacPolicySimulateResponses,
  OrgRbacPolicyUpdateData,
  OrgRbacPolicyUpdateErrors,
  OrgRbacPolicyUpdateResponses,
  OrgRbacPolicyValidateData,
  OrgRbacPolicyValidateErrors,
  OrgRbacPolicyValidateResponses,
  OrgScimConfigCreateData,
  OrgScimConfigCreateErrors,
  OrgScimConfigCreateResponses,
  OrgScimConfigDeleteData,
  OrgScimConfigDeleteErrors,
  OrgScimConfigDeleteResponses,
  OrgScimConfigGetData,
  OrgScimConfigGetErrors,
  OrgScimConfigGetResponses,
  OrgScimConfigRotateTokenData,
  OrgScimConfigRotateTokenErrors,
  OrgScimConfigRotateTokenResponses,
  OrgScimConfigUpdateData,
  OrgScimConfigUpdateErrors,
  OrgScimConfigUpdateResponses,
  OrgSsoConfigCreateData,
  OrgSsoConfigCreateErrors,
  OrgSsoConfigCreateResponses,
  OrgSsoConfigDeleteData,
  OrgSsoConfigDeleteErrors,
  OrgSsoConfigDeleteResponses,
  OrgSsoConfigGetData,
  OrgSsoConfigGetErrors,
  OrgSsoConfigGetResponses,
  OrgSsoConfigGetSpMetadataData,
  OrgSsoConfigGetSpMetadataErrors,
  OrgSsoConfigGetSpMetadataResponses,
  OrgSsoConfigParseSamlMetadataData,
  OrgSsoConfigParseSamlMetadataErrors,
  OrgSsoConfigParseSamlMetadataResponses,
  OrgSsoConfigUpdateData,
  OrgSsoConfigUpdateErrors,
  OrgSsoConfigUpdateResponses,
  ProjectCreateData,
  ProjectCreateErrors,
  ProjectCreateResponses,
  ProjectDeleteData,
  ProjectDeleteErrors,
  ProjectDeleteResponses,
  ProjectGetData,
  ProjectGetErrors,
  ProjectGetResponses,
  ProjectListData,
  ProjectListErrors,
  ProjectListResponses,
  ProjectMemberAddData,
  ProjectMemberAddErrors,
  ProjectMemberAddResponses,
  ProjectMemberListData,
  ProjectMemberListErrors,
  ProjectMemberListResponses,
  ProjectMemberRemoveData,
  ProjectMemberRemoveErrors,
  ProjectMemberRemoveResponses,
  ProjectUpdateData,
  ProjectUpdateErrors,
  ProjectUpdateResponses,
  ServiceAccountCreateData,
  ServiceAccountCreateErrors,
  ServiceAccountCreateResponses,
  ServiceAccountDeleteData,
  ServiceAccountDeleteErrors,
  ServiceAccountDeleteResponses,
  ServiceAccountGetData,
  ServiceAccountGetErrors,
  ServiceAccountGetResponses,
  ServiceAccountListData,
  ServiceAccountListErrors,
  ServiceAccountListResponses,
  ServiceAccountUpdateData,
  ServiceAccountUpdateErrors,
  ServiceAccountUpdateResponses,
  SessionInfoGetData,
  SessionInfoGetErrors,
  SessionInfoGetResponses,
  SkillCreateData,
  SkillCreateErrors,
  SkillCreateResponses,
  SkillCreateVersionData,
  SkillCreateVersionErrors,
  SkillCreateVersionResponses,
  SkillDeleteData,
  SkillDeleteErrors,
  SkillDeleteResponses,
  SkillDeleteVersionData,
  SkillDeleteVersionErrors,
  SkillDeleteVersionResponses,
  SkillGetContentData,
  SkillGetContentErrors,
  SkillGetContentResponses,
  SkillGetData,
  SkillGetErrors,
  SkillGetResponses,
  SkillGetVersionContentData,
  SkillGetVersionContentErrors,
  SkillGetVersionContentResponses,
  SkillGetVersionData,
  SkillGetVersionErrors,
  SkillGetVersionResponses,
  SkillListData,
  SkillListErrors,
  SkillListResponses,
  SkillListVersionsData,
  SkillListVersionsErrors,
  SkillListVersionsResponses,
  SkillSetDefaultVersionData,
  SkillSetDefaultVersionErrors,
  SkillSetDefaultVersionResponses,
  SsoConnectionGetData,
  SsoConnectionGetErrors,
  SsoConnectionGetResponses,
  SsoConnectionsListData,
  SsoConnectionsListErrors,
  SsoConnectionsListResponses,
  SsoGroupMappingCreateData,
  SsoGroupMappingCreateErrors,
  SsoGroupMappingCreateResponses,
  SsoGroupMappingDeleteData,
  SsoGroupMappingDeleteErrors,
  SsoGroupMappingDeleteResponses,
  SsoGroupMappingExportData,
  SsoGroupMappingExportErrors,
  SsoGroupMappingExportResponses,
  SsoGroupMappingGetData,
  SsoGroupMappingGetErrors,
  SsoGroupMappingGetResponses,
  SsoGroupMappingImportData,
  SsoGroupMappingImportErrors,
  SsoGroupMappingImportResponses,
  SsoGroupMappingListData,
  SsoGroupMappingListErrors,
  SsoGroupMappingListResponses,
  SsoGroupMappingTestData,
  SsoGroupMappingTestErrors,
  SsoGroupMappingTestResponses,
  SsoGroupMappingUpdateData,
  SsoGroupMappingUpdateErrors,
  SsoGroupMappingUpdateResponses,
  StaleAccessDetectionData,
  StaleAccessDetectionErrors,
  StaleAccessDetectionResponses,
  TeamCreateData,
  TeamCreateErrors,
  TeamCreateResponses,
  TeamDeleteData,
  TeamDeleteErrors,
  TeamDeleteResponses,
  TeamGetData,
  TeamGetErrors,
  TeamGetResponses,
  TeamListData,
  TeamListErrors,
  TeamListResponses,
  TeamMemberAddData,
  TeamMemberAddErrors,
  TeamMemberAddResponses,
  TeamMemberListData,
  TeamMemberListErrors,
  TeamMemberListResponses,
  TeamMemberRemoveData,
  TeamMemberRemoveErrors,
  TeamMemberRemoveResponses,
  TeamMemberUpdateData,
  TeamMemberUpdateErrors,
  TeamMemberUpdateResponses,
  TeamUpdateData,
  TeamUpdateErrors,
  TeamUpdateResponses,
  TemplateCreateData,
  TemplateCreateErrors,
  TemplateCreateResponses,
  TemplateDeleteData,
  TemplateDeleteErrors,
  TemplateDeleteResponses,
  TemplateGetData,
  TemplateGetErrors,
  TemplateGetResponses,
  TemplateListByOrgData,
  TemplateListByOrgErrors,
  TemplateListByOrgResponses,
  TemplateListByProjectData,
  TemplateListByProjectErrors,
  TemplateListByProjectResponses,
  TemplateListByTeamData,
  TemplateListByTeamErrors,
  TemplateListByTeamResponses,
  TemplateListByUserData,
  TemplateListByUserErrors,
  TemplateListByUserResponses,
  TemplateUpdateData,
  TemplateUpdateErrors,
  TemplateUpdateResponses,
  UsageGetByDateData,
  UsageGetByDateErrors,
  UsageGetByDateModelData,
  UsageGetByDateModelResponses,
  UsageGetByDatePricingSourceData,
  UsageGetByDatePricingSourceResponses,
  UsageGetByDateProviderData,
  UsageGetByDateProviderResponses,
  UsageGetByDateResponses,
  UsageGetByModelData,
  UsageGetByModelErrors,
  UsageGetByModelResponses,
  UsageGetByPricingSourceData,
  UsageGetByPricingSourceResponses,
  UsageGetByProviderData,
  UsageGetByProviderErrors,
  UsageGetByProviderResponses,
  UsageGetByRefererData,
  UsageGetByRefererErrors,
  UsageGetByRefererResponses,
  UsageGetForecastData,
  UsageGetForecastErrors,
  UsageGetForecastResponses,
  UsageGetGlobalByDateData,
  UsageGetGlobalByDateModelData,
  UsageGetGlobalByDateModelResponses,
  UsageGetGlobalByDateOrgData,
  UsageGetGlobalByDateOrgResponses,
  UsageGetGlobalByDatePricingSourceData,
  UsageGetGlobalByDatePricingSourceResponses,
  UsageGetGlobalByDateProjectData,
  UsageGetGlobalByDateProjectResponses,
  UsageGetGlobalByDateProviderData,
  UsageGetGlobalByDateProviderResponses,
  UsageGetGlobalByDateResponses,
  UsageGetGlobalByDateTeamData,
  UsageGetGlobalByDateTeamResponses,
  UsageGetGlobalByDateUserData,
  UsageGetGlobalByDateUserResponses,
  UsageGetGlobalByModelData,
  UsageGetGlobalByModelResponses,
  UsageGetGlobalByOrgData,
  UsageGetGlobalByOrgResponses,
  UsageGetGlobalByPricingSourceData,
  UsageGetGlobalByPricingSourceResponses,
  UsageGetGlobalByProjectData,
  UsageGetGlobalByProjectResponses,
  UsageGetGlobalByProviderData,
  UsageGetGlobalByProviderResponses,
  UsageGetGlobalByTeamData,
  UsageGetGlobalByTeamResponses,
  UsageGetGlobalByUserData,
  UsageGetGlobalByUserResponses,
  UsageGetGlobalSummaryData,
  UsageGetGlobalSummaryResponses,
  UsageGetOrgByDateData,
  UsageGetOrgByDateErrors,
  UsageGetOrgByDateModelData,
  UsageGetOrgByDateModelResponses,
  UsageGetOrgByDatePricingSourceData,
  UsageGetOrgByDatePricingSourceResponses,
  UsageGetOrgByDateProjectData,
  UsageGetOrgByDateProjectErrors,
  UsageGetOrgByDateProjectResponses,
  UsageGetOrgByDateProviderData,
  UsageGetOrgByDateProviderResponses,
  UsageGetOrgByDateResponses,
  UsageGetOrgByDateTeamData,
  UsageGetOrgByDateTeamErrors,
  UsageGetOrgByDateTeamResponses,
  UsageGetOrgByDateUserData,
  UsageGetOrgByDateUserErrors,
  UsageGetOrgByDateUserResponses,
  UsageGetOrgByModelData,
  UsageGetOrgByModelErrors,
  UsageGetOrgByModelResponses,
  UsageGetOrgByPricingSourceData,
  UsageGetOrgByPricingSourceResponses,
  UsageGetOrgByProjectData,
  UsageGetOrgByProjectErrors,
  UsageGetOrgByProjectResponses,
  UsageGetOrgByProviderData,
  UsageGetOrgByProviderErrors,
  UsageGetOrgByProviderResponses,
  UsageGetOrgByTeamData,
  UsageGetOrgByTeamErrors,
  UsageGetOrgByTeamResponses,
  UsageGetOrgByUserData,
  UsageGetOrgByUserErrors,
  UsageGetOrgByUserResponses,
  UsageGetOrgForecastData,
  UsageGetOrgForecastErrors,
  UsageGetOrgForecastResponses,
  UsageGetOrgSummaryData,
  UsageGetOrgSummaryErrors,
  UsageGetOrgSummaryResponses,
  UsageGetProjectByDateData,
  UsageGetProjectByDateErrors,
  UsageGetProjectByDateModelData,
  UsageGetProjectByDateModelResponses,
  UsageGetProjectByDatePricingSourceData,
  UsageGetProjectByDatePricingSourceResponses,
  UsageGetProjectByDateProviderData,
  UsageGetProjectByDateProviderResponses,
  UsageGetProjectByDateResponses,
  UsageGetProjectByDateUserData,
  UsageGetProjectByDateUserErrors,
  UsageGetProjectByDateUserResponses,
  UsageGetProjectByModelData,
  UsageGetProjectByModelErrors,
  UsageGetProjectByModelResponses,
  UsageGetProjectByPricingSourceData,
  UsageGetProjectByPricingSourceResponses,
  UsageGetProjectByProviderData,
  UsageGetProjectByProviderErrors,
  UsageGetProjectByProviderResponses,
  UsageGetProjectByUserData,
  UsageGetProjectByUserErrors,
  UsageGetProjectByUserResponses,
  UsageGetProjectForecastData,
  UsageGetProjectForecastErrors,
  UsageGetProjectForecastResponses,
  UsageGetProjectSummaryData,
  UsageGetProjectSummaryErrors,
  UsageGetProjectSummaryResponses,
  UsageGetProviderByDateData,
  UsageGetProviderByDateResponses,
  UsageGetProviderByModelData,
  UsageGetProviderByModelResponses,
  UsageGetProviderForecastData,
  UsageGetProviderForecastResponses,
  UsageGetProviderSummaryData,
  UsageGetProviderSummaryResponses,
  UsageGetSummaryData,
  UsageGetSummaryErrors,
  UsageGetSummaryResponses,
  UsageGetTeamByDateData,
  UsageGetTeamByDateErrors,
  UsageGetTeamByDateModelData,
  UsageGetTeamByDateModelResponses,
  UsageGetTeamByDatePricingSourceData,
  UsageGetTeamByDatePricingSourceResponses,
  UsageGetTeamByDateProjectData,
  UsageGetTeamByDateProjectErrors,
  UsageGetTeamByDateProjectResponses,
  UsageGetTeamByDateProviderData,
  UsageGetTeamByDateProviderResponses,
  UsageGetTeamByDateResponses,
  UsageGetTeamByDateUserData,
  UsageGetTeamByDateUserErrors,
  UsageGetTeamByDateUserResponses,
  UsageGetTeamByModelData,
  UsageGetTeamByModelErrors,
  UsageGetTeamByModelResponses,
  UsageGetTeamByPricingSourceData,
  UsageGetTeamByPricingSourceResponses,
  UsageGetTeamByProjectData,
  UsageGetTeamByProjectErrors,
  UsageGetTeamByProjectResponses,
  UsageGetTeamByProviderData,
  UsageGetTeamByProviderErrors,
  UsageGetTeamByProviderResponses,
  UsageGetTeamByUserData,
  UsageGetTeamByUserErrors,
  UsageGetTeamByUserResponses,
  UsageGetTeamForecastData,
  UsageGetTeamForecastErrors,
  UsageGetTeamForecastResponses,
  UsageGetTeamSummaryData,
  UsageGetTeamSummaryErrors,
  UsageGetTeamSummaryResponses,
  UsageGetUserByDateData,
  UsageGetUserByDateErrors,
  UsageGetUserByDateModelData,
  UsageGetUserByDateModelResponses,
  UsageGetUserByDatePricingSourceData,
  UsageGetUserByDatePricingSourceResponses,
  UsageGetUserByDateProviderData,
  UsageGetUserByDateProviderResponses,
  UsageGetUserByDateResponses,
  UsageGetUserByModelData,
  UsageGetUserByModelErrors,
  UsageGetUserByModelResponses,
  UsageGetUserByPricingSourceData,
  UsageGetUserByPricingSourceResponses,
  UsageGetUserByProviderData,
  UsageGetUserByProviderErrors,
  UsageGetUserByProviderResponses,
  UsageGetUserForecastData,
  UsageGetUserForecastErrors,
  UsageGetUserForecastResponses,
  UsageGetUserSummaryData,
  UsageGetUserSummaryErrors,
  UsageGetUserSummaryResponses,
  UsageLogExportData,
  UsageLogExportResponses,
  UsageLogListData,
  UsageLogListResponses,
  UserAccessSummaryData,
  UserAccessSummaryErrors,
  UserAccessSummaryResponses,
  UserCreateData,
  UserCreateErrors,
  UserCreateResponses,
  UserDeleteData,
  UserDeleteErrors,
  UserDeleteResponses,
  UserExportData,
  UserExportErrors,
  UserExportResponses,
  UserGetData,
  UserGetErrors,
  UserGetResponses,
  UserListData,
  UserListErrors,
  UserListResponses,
  UserSessionsDeleteAllData,
  UserSessionsDeleteAllErrors,
  UserSessionsDeleteAllResponses,
  UserSessionsDeleteOneData,
  UserSessionsDeleteOneErrors,
  UserSessionsDeleteOneResponses,
  UserSessionsListData,
  UserSessionsListErrors,
  UserSessionsListResponses,
  UserUpdateData,
  UserUpdateErrors,
  UserUpdateResponses,
  VectorStoreCreateData,
  VectorStoreCreateErrors,
  VectorStoreCreateResponses,
  VectorStoreDeleteData,
  VectorStoreDeleteErrors,
  VectorStoreDeleteResponses,
  VectorStoreFileBatchCancelData,
  VectorStoreFileBatchCancelErrors,
  VectorStoreFileBatchCreateData,
  VectorStoreFileBatchCreateErrors,
  VectorStoreFileBatchCreateResponses,
  VectorStoreFileBatchGetData,
  VectorStoreFileBatchGetErrors,
  VectorStoreFileBatchListFilesData,
  VectorStoreFileBatchListFilesErrors,
  VectorStoreFileChunksListData,
  VectorStoreFileChunksListErrors,
  VectorStoreFileChunksListResponses,
  VectorStoreFileCreateData,
  VectorStoreFileCreateErrors,
  VectorStoreFileCreateResponses,
  VectorStoreFileDeleteData,
  VectorStoreFileDeleteErrors,
  VectorStoreFileDeleteResponses,
  VectorStoreFileGetData,
  VectorStoreFileGetErrors,
  VectorStoreFileGetResponses,
  VectorStoreFileListData,
  VectorStoreFileListErrors,
  VectorStoreFileListResponses,
  VectorStoreGetData,
  VectorStoreGetErrors,
  VectorStoreGetResponses,
  VectorStoreListData,
  VectorStoreListErrors,
  VectorStoreListResponses,
  VectorStoreModifyData,
  VectorStoreModifyErrors,
  VectorStoreModifyResponses,
  VectorStoreSearchData,
  VectorStoreSearchErrors,
  VectorStoreSearchResponses,
  WebFetchData,
  WebFetchErrors,
  WebFetchResponses,
  WebSearchData,
  WebSearchErrors,
  WebSearchResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Serve the OAuth 2.0 Authorization Server Metadata document.
 */
export const oauthAuthorizationServerMetadata = <ThrowOnError extends boolean = false>(
  options?: Options<OauthAuthorizationServerMetadataData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    OauthAuthorizationServerMetadataResponses,
    OauthAuthorizationServerMetadataErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/.well-known/oauth-authorization-server",
    ...options,
  });

/**
 * Get access inventory for compliance reviews
 *
 * Returns a comprehensive view of all users and their access rights across
 * organizations and projects. This endpoint supports compliance requirements
 * for access reviews (SOC 2, ISO 27001).
 *
 * The response includes:
 * - User details (id, email, name, external_id)
 * - Organization memberships with roles and grant dates
 * - Project memberships with roles and grant dates
 * - API key summary (active, revoked, expired counts)
 * - Last activity timestamp
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const accessReviewInventory = <ThrowOnError extends boolean = false>(
  options?: Options<AccessReviewInventoryData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AccessReviewInventoryResponses,
    AccessReviewInventoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/access-reviews/inventory",
    ...options,
  });

/**
 * Detect stale access across the system
 *
 * Identifies users and API keys that haven't been active for a configurable
 * number of days. This helps identify:
 * - Users who haven't logged in or performed any actions
 * - API keys that haven't been used
 * - Users with access but no recorded activity
 *
 * This endpoint supports compliance requirements for periodic access reviews
 * (SOC 2, ISO 27001) by identifying potentially orphaned or unused access.
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const staleAccessDetection = <ThrowOnError extends boolean = false>(
  options?: Options<StaleAccessDetectionData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    StaleAccessDetectionResponses,
    StaleAccessDetectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/access-reviews/stale",
    ...options,
  });

/**
 * Create an API key
 *
 * Creates a new API key scoped to an organization, project, or user. The raw API key value
 * is returned only once in this response and cannot be retrieved later. Store it securely.
 */
export const apiKeyCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiKeyCreateResponses, ApiKeyCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke an API key
 */
export const apiKeyRevoke = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyRevokeData, ThrowOnError>
) =>
  (options.client ?? client).delete<ApiKeyRevokeResponses, ApiKeyRevokeErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}",
    ...options,
  });

/**
 * Rotate an API key
 *
 * Creates a new API key with the same settings as the old key and sets a grace period
 * on the old key. During the grace period, both keys are valid. After the grace period
 * expires, only the new key works.
 *
 * The raw API key value for the new key is returned only once in this response.
 */
export const apiKeyRotate = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyRotateData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiKeyRotateResponses, ApiKeyRotateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/rotate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get usage summary for an API key
 */
export const usageGetSummary = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetSummaryResponses, UsageGetSummaryErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage",
    ...options,
  });

/**
 * Get usage by date for an API key
 */
export const usageGetByDate = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByDateData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByDateResponses, UsageGetByDateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-date",
    ...options,
  });

/**
 * Get usage by date and model for an API key
 */
export const usageGetByDateModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByDateModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-date-model",
    ...options,
  });

/**
 * Get usage by date and pricing source for an API key
 */
export const usageGetByDatePricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByDatePricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByDatePricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get usage by date and provider for an API key
 */
export const usageGetByDateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByDateProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-date-provider",
    ...options,
  });

/**
 * Get usage by model for an API key
 */
export const usageGetByModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByModelResponses, UsageGetByModelErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-model",
    ...options,
  });

/**
 * Get usage by pricing source for an API key
 */
export const usageGetByPricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByPricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-pricing-source",
    ...options,
  });

/**
 * Get usage by provider for an API key
 */
export const usageGetByProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetByProviderResponses,
    UsageGetByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/by-provider",
    ...options,
  });

/**
 * Get usage by referer for an API key
 */
export const usageGetByReferer = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetByRefererData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetByRefererResponses, UsageGetByRefererErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/api-keys/{key_id}/usage/by-referer",
      ...options,
    }
  );

/**
 * Get cost forecast for an API key
 *
 * Uses historical usage data to predict when the budget will be exhausted.
 * Returns average daily spend, projected exhaustion date, and confidence intervals.
 */
export const usageGetForecast = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetForecastData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetForecastResponses, UsageGetForecastErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/api-keys/{key_id}/usage/forecast",
    ...options,
  });

/**
 * List audit logs
 *
 * When neither `from` nor `to` is supplied, results default to the last
 * 7 days (the audit log is append-only and an unbounded scan would hit
 * the entire table). Pass an explicit `from` for older entries.
 */
export const auditLogList = <ThrowOnError extends boolean = false>(
  options?: Options<AuditLogListData, ThrowOnError>
) =>
  (options?.client ?? client).get<AuditLogListResponses, AuditLogListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/audit-logs",
    ...options,
  });

/**
 * Get an audit log entry by ID
 */
export const auditLogGet = <ThrowOnError extends boolean = false>(
  options: Options<AuditLogGetData, ThrowOnError>
) =>
  (options.client ?? client).get<AuditLogGetResponses, AuditLogGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/audit-logs/{id}",
    ...options,
  });

/**
 * Create a new conversation
 */
export const conversationCreate = <ThrowOnError extends boolean = false>(
  options: Options<ConversationCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConversationCreateResponses,
    ConversationCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/conversations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a conversation
 */
export const conversationDelete = <ThrowOnError extends boolean = false>(
  options: Options<ConversationDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ConversationDeleteResponses,
    ConversationDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/conversations/{id}",
    ...options,
  });

/**
 * Get a conversation by ID
 */
export const conversationGet = <ThrowOnError extends boolean = false>(
  options: Options<ConversationGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ConversationGetResponses, ConversationGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/conversations/{id}",
    ...options,
  });

/**
 * Update a conversation
 *
 * Can also be used to move a conversation to a different project or user by providing the `owner` field.
 */
export const conversationUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ConversationUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ConversationUpdateResponses,
    ConversationUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/conversations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Append messages to a conversation
 */
export const conversationAppendMessages = <ThrowOnError extends boolean = false>(
  options: Options<ConversationAppendMessagesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ConversationAppendMessagesResponses,
    ConversationAppendMessagesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/conversations/{id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set pin order for a conversation
 *
 * Set `pin_order` to a number to pin the conversation (0 = first, higher = lower in list).
 * Set `pin_order` to null to unpin the conversation.
 */
export const conversationSetPin = <ThrowOnError extends boolean = false>(
  options: Options<ConversationSetPinData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ConversationSetPinResponses,
    ConversationSetPinErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/conversations/{id}/pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Purge all DLQ entries.
 */
export const dlqPurge = <ThrowOnError extends boolean = false>(
  options?: Options<DlqPurgeData, ThrowOnError>
) =>
  (options?.client ?? client).delete<DlqPurgeResponses, DlqPurgeErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq",
    ...options,
  });

/**
 * List DLQ entries.
 */
export const dlqList = <ThrowOnError extends boolean = false>(
  options?: Options<DlqListData, ThrowOnError>
) =>
  (options?.client ?? client).get<DlqListResponses, DlqListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq",
    ...options,
  });

export const dlqPrune = <ThrowOnError extends boolean = false>(
  options?: Options<DlqPruneData, ThrowOnError>
) =>
  (options?.client ?? client).post<DlqPruneResponses, DlqPruneErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq/prune",
    ...options,
  });

/**
 * Get DLQ statistics.
 */
export const dlqStats = <ThrowOnError extends boolean = false>(
  options?: Options<DlqStatsData, ThrowOnError>
) =>
  (options?.client ?? client).get<DlqStatsResponses, DlqStatsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq/stats",
    ...options,
  });

/**
 * Delete a DLQ entry.
 */
export const dlqDelete = <ThrowOnError extends boolean = false>(
  options: Options<DlqDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<DlqDeleteResponses, DlqDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq/{id}",
    ...options,
  });

/**
 * Get a specific DLQ entry by ID.
 */
export const dlqGet = <ThrowOnError extends boolean = false>(
  options: Options<DlqGetData, ThrowOnError>
) =>
  (options.client ?? client).get<DlqGetResponses, DlqGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq/{id}",
    ...options,
  });

/**
 * Retry a specific DLQ entry.
 */
export const dlqRetry = <ThrowOnError extends boolean = false>(
  options: Options<DlqRetryData, ThrowOnError>
) =>
  (options.client ?? client).post<DlqRetryResponses, DlqRetryErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dlq/{id}/retry",
    ...options,
  });

/**
 * Create a dynamic provider
 */
export const dynamicProviderCreate = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DynamicProviderCreateResponses,
    DynamicProviderCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dynamic-providers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test credentials before creating a dynamic provider
 *
 * Accepts the same body as the create endpoint but does not persist anything.
 * Useful for validating API keys and endpoints before committing.
 */
export const dynamicProviderTestCredentials = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderTestCredentialsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DynamicProviderTestCredentialsResponses,
    DynamicProviderTestCredentialsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dynamic-providers/test-credentials",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a dynamic provider
 */
export const dynamicProviderDelete = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DynamicProviderDeleteResponses,
    DynamicProviderDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dynamic-providers/{id}",
    ...options,
  });

/**
 * Get a dynamic provider by ID
 */
export const dynamicProviderGet = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DynamicProviderGetResponses,
    DynamicProviderGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dynamic-providers/{id}",
    ...options,
  });

/**
 * Update a dynamic provider
 */
export const dynamicProviderUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DynamicProviderUpdateResponses,
    DynamicProviderUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dynamic-providers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test connectivity for an existing dynamic provider
 *
 * Sends a lightweight request to the provider to verify the API key and endpoint are working.
 */
export const dynamicProviderTest = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderTestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DynamicProviderTestResponses,
    DynamicProviderTestErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/dynamic-providers/{id}/test",
    ...options,
  });

/**
 * Delete current user and all associated data (GDPR Article 17 - Right to Erasure)
 *
 * Permanently deletes the authenticated user and all associated data including:
 * - User record
 * - Organization and project memberships
 * - API keys owned by the user
 * - Conversations owned by the user
 * - Dynamic providers owned by the user
 * - Usage records for user's API keys
 *
 * This endpoint allows users to delete their own account without admin permissions.
 * The user is identified from the authenticated session.
 *
 * **Warning:** This operation is irreversible.
 */
export const meDelete = <ThrowOnError extends boolean = false>(
  options?: Options<MeDeleteData, ThrowOnError>
) =>
  (options?.client ?? client).delete<MeDeleteResponses, MeDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me",
    ...options,
  });

/**
 * List current user's API keys
 */
export const meApiKeysList = <ThrowOnError extends boolean = false>(
  options?: Options<MeApiKeysListData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeApiKeysListResponses, MeApiKeysListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/api-keys",
    ...options,
  });

/**
 * Create an API key for the current user
 */
export const meApiKeysCreate = <ThrowOnError extends boolean = false>(
  options: Options<MeApiKeysCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<MeApiKeysCreateResponses, MeApiKeysCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke an API key (current user only)
 */
export const meApiKeysRevoke = <ThrowOnError extends boolean = false>(
  options: Options<MeApiKeysRevokeData, ThrowOnError>
) =>
  (options.client ?? client).delete<MeApiKeysRevokeResponses, MeApiKeysRevokeErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/api-keys/{key_id}",
    ...options,
  });

/**
 * Get an API key by ID (current user only)
 */
export const meApiKeysGet = <ThrowOnError extends boolean = false>(
  options: Options<MeApiKeysGetData, ThrowOnError>
) =>
  (options.client ?? client).get<MeApiKeysGetResponses, MeApiKeysGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/api-keys/{key_id}",
    ...options,
  });

/**
 * Rotate an API key (current user only)
 *
 * Creates a new API key with the same settings as the old key and sets a grace period
 * on the old key. During the grace period, both keys are valid.
 */
export const meApiKeysRotate = <ThrowOnError extends boolean = false>(
  options: Options<MeApiKeysRotateData, ThrowOnError>
) =>
  (options.client ?? client).post<MeApiKeysRotateResponses, MeApiKeysRotateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/api-keys/{key_id}/rotate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List built-in providers from the gateway configuration
 */
export const meBuiltInProvidersList = <ThrowOnError extends boolean = false>(
  options?: Options<MeBuiltInProvidersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeBuiltInProvidersListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/built-in-providers",
    ...options,
  });

/**
 * List the owners the current user can plausibly issue an API key for.
 *
 * This is a hint for the OAuth consent UI; the actual create-permission
 * check still runs server-side at consent time, so an owner appearing
 * here doesn't guarantee the create will succeed if RBAC denies it.
 */
export const meEligibleOwners = <ThrowOnError extends boolean = false>(
  options?: Options<MeEligibleOwnersData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeEligibleOwnersResponses, MeEligibleOwnersErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/eligible-owners",
    ...options,
  });

/**
 * Export current user's data (GDPR Article 15 - Right of Access)
 *
 * Exports all personal data associated with the authenticated user including:
 * - User profile
 * - Organization and project memberships
 * - API keys (excluding sensitive hash)
 * - Conversations
 * - Usage summary
 * - Audit logs where user was the actor
 *
 * This endpoint allows users to export their own data without admin permissions.
 * The user is identified from the authenticated session.
 */
export const meExport = <ThrowOnError extends boolean = false>(
  options?: Options<MeExportData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeExportResponses, MeExportErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/export",
    ...options,
  });

/**
 * List current user's dynamic providers
 */
export const meProvidersList = <ThrowOnError extends boolean = false>(
  options?: Options<MeProvidersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeProvidersListResponses, MeProvidersListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers",
    ...options,
  });

/**
 * Create a dynamic provider for the current user
 */
export const meProvidersCreate = <ThrowOnError extends boolean = false>(
  options: Options<MeProvidersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MeProvidersCreateResponses,
    MeProvidersCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test credentials before creating a provider
 *
 * Accepts the same body as the create endpoint but does not persist anything.
 * Useful for validating API keys and endpoints before committing.
 */
export const meProvidersTestCredentials = <ThrowOnError extends boolean = false>(
  options: Options<MeProvidersTestCredentialsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MeProvidersTestCredentialsResponses,
    MeProvidersTestCredentialsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers/test-credentials",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a dynamic provider (current user only)
 */
export const meProvidersDelete = <ThrowOnError extends boolean = false>(
  options: Options<MeProvidersDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    MeProvidersDeleteResponses,
    MeProvidersDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers/{id}",
    ...options,
  });

/**
 * Get a dynamic provider by ID (current user only)
 */
export const meProvidersGet = <ThrowOnError extends boolean = false>(
  options: Options<MeProvidersGetData, ThrowOnError>
) =>
  (options.client ?? client).get<MeProvidersGetResponses, MeProvidersGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers/{id}",
    ...options,
  });

/**
 * Update a dynamic provider (current user only)
 */
export const meProvidersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MeProvidersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    MeProvidersUpdateResponses,
    MeProvidersUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test connectivity for a dynamic provider (current user only)
 *
 * Sends a lightweight request to the provider to verify the API key and endpoint are working.
 */
export const meProvidersTest = <ThrowOnError extends boolean = false>(
  options: Options<MeProvidersTestData, ThrowOnError>
) =>
  (options.client ?? client).post<MeProvidersTestResponses, MeProvidersTestErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/providers/{id}/test",
    ...options,
  });

/**
 * List current user's active sessions.
 *
 * Returns an empty list if enhanced session management is not enabled.
 * The `enhanced_enabled` field indicates whether session tracking is active.
 */
export const meSessionsList = <ThrowOnError extends boolean = false>(
  options?: Options<MeSessionsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeSessionsListResponses, MeSessionsListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/sessions",
    ...options,
  });

/**
 * Revoke a specific session belonging to the current user.
 *
 * Returns success even if the session doesn't exist (idempotent).
 * Returns 400 if the session belongs to a different user.
 */
export const meSessionsDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<MeSessionsDeleteOneData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    MeSessionsDeleteOneResponses,
    MeSessionsDeleteOneErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/sessions/{session_id}",
    ...options,
  });

/**
 * Get current user's usage summary
 *
 * Returns usage data for the authenticated user. Does not require admin role.
 */
export const meUsageSummary = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageSummaryData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageSummaryResponses, MeUsageSummaryErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage",
    ...options,
  });

/**
 * Get current user's usage by date
 */
export const meUsageByDate = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByDateData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageByDateResponses, MeUsageByDateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-date",
    ...options,
  });

/**
 * Get current user's usage by date and model
 */
export const meUsageByDateModel = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByDateModelData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-date-model",
    ...options,
  });

/**
 * Get current user's usage by date and pricing source
 */
export const meUsageByDatePricingSource = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByDatePricingSourceData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageByDatePricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get current user's usage by date and provider
 */
export const meUsageByDateProvider = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByDateProviderData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-date-provider",
    ...options,
  });

/**
 * Get current user's usage by model
 */
export const meUsageByModel = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByModelData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageByModelResponses, MeUsageByModelErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-model",
    ...options,
  });

/**
 * Get current user's usage by pricing source
 */
export const meUsageByPricingSource = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByPricingSourceData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-pricing-source",
    ...options,
  });

/**
 * Get current user's usage by provider
 */
export const meUsageByProvider = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageByProviderData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    MeUsageByProviderResponses,
    MeUsageByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/by-provider",
    ...options,
  });

/**
 * List current user's usage logs
 */
export const meUsageLogList = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageLogListData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageLogListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/logs",
    ...options,
  });

/**
 * Export current user's usage logs
 */
export const meUsageLogExport = <ThrowOnError extends boolean = false>(
  options?: Options<MeUsageLogExportData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeUsageLogExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/me/usage/logs/export",
    ...options,
  });

/**
 * List global model pricing
 */
export const modelPricingListGlobal = <ThrowOnError extends boolean = false>(
  options?: Options<ModelPricingListGlobalData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ModelPricingListGlobalResponses,
    ModelPricingListGlobalErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing",
    ...options,
  });

/**
 * Create a new model pricing entry
 */
export const modelPricingCreate = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ModelPricingCreateResponses,
    ModelPricingCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk upsert model pricing entries
 */
export const modelPricingBulkUpsert = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingBulkUpsertData, ThrowOnError>
) =>
  (options.client ?? client).post<ModelPricingBulkUpsertResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all pricing for a specific provider (across all scopes)
 */
export const modelPricingListByProvider = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingListByProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ModelPricingListByProviderResponses,
    ModelPricingListByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing/provider/{provider}",
    ...options,
  });

/**
 * Upsert model pricing (create or update based on owner/provider/model)
 */
export const modelPricingUpsert = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingUpsertData, ThrowOnError>
) =>
  (options.client ?? client).post<ModelPricingUpsertResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing/upsert",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a model pricing entry
 */
export const modelPricingDelete = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ModelPricingDeleteResponses,
    ModelPricingDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing/{id}",
    ...options,
  });

/**
 * Get a model pricing entry by ID
 */
export const modelPricingGet = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ModelPricingGetResponses, ModelPricingGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing/{id}",
    ...options,
  });

/**
 * Update a model pricing entry
 */
export const modelPricingUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ModelPricingUpdateResponses,
    ModelPricingUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/model-pricing/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Issue an authorization code after explicit user consent.
 *
 * The browser calls this endpoint from the consent page when the user clicks
 * "Allow". The endpoint:
 *
 * 1. Validates the requested scopes and key name shape (mirroring the
 * self-service API key endpoint), so we reject obvious mistakes before
 * issuing the code.
 * 2. Validates the callback URL scheme and host against
 * `auth.oauth_pkce.allowed_domains` / `denied_domains`.
 * 3. Persists a single-use authorization code bound to the current user
 * and the supplied PKCE challenge.
 * 4. Returns the redirect URL the page should send the browser to.
 */
export const oauthAuthorize = <ThrowOnError extends boolean = false>(
  options: Options<OauthAuthorizeData, ThrowOnError>
) =>
  (options.client ?? client).post<OauthAuthorizeResponses, OauthAuthorizeErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/oauth/authorize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Validate a `callback_url` against the deployment's OAuth PKCE policy
 * without issuing a code. The consent UI calls this on mount and refuses
 * to render if the URL is rejected — closing the gap where a "Deny"
 * click could otherwise redirect to a host the operator denied.
 */
export const oauthPreflight = <ThrowOnError extends boolean = false>(
  options: Options<OauthPreflightData, ThrowOnError>
) =>
  (options.client ?? client).get<OauthPreflightResponses, OauthPreflightErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/oauth/preflight",
    ...options,
  });

/**
 * List all organizations
 */
export const organizationList = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationListData, ThrowOnError>
) =>
  (options?.client ?? client).get<OrganizationListResponses, OrganizationListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations",
    ...options,
  });

/**
 * Create an organization
 */
export const organizationCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrganizationCreateResponses,
    OrganizationCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get access report for a specific organization
 *
 * Returns a comprehensive access report for the specified organization including:
 * - All org members with their roles and project access
 * - All API keys scoped to the organization or its projects
 * - Recent access grant history from audit logs
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const orgAccessReport = <ThrowOnError extends boolean = false>(
  options: Options<OrgAccessReportData, ThrowOnError>
) =>
  (options.client ?? client).get<OrgAccessReportResponses, OrgAccessReportErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/access-report",
    ...options,
  });

/**
 * List API keys by organization
 */
export const apiKeyListByOrg = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyListByOrgData, ThrowOnError>
) =>
  (options.client ?? client).get<ApiKeyListByOrgResponses, ApiKeyListByOrgErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/api-keys",
    ...options,
  });

/**
 * List dynamic providers by organization
 */
export const dynamicProviderListByOrg = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderListByOrgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DynamicProviderListByOrgResponses,
    DynamicProviderListByOrgErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/dynamic-providers",
    ...options,
  });

/**
 * List organization members
 */
export const orgMemberList = <ThrowOnError extends boolean = false>(
  options: Options<OrgMemberListData, ThrowOnError>
) =>
  (options.client ?? client).get<OrgMemberListResponses, OrgMemberListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/members",
    ...options,
  });

/**
 * Add a member to an organization
 */
export const orgMemberAdd = <ThrowOnError extends boolean = false>(
  options: Options<OrgMemberAddData, ThrowOnError>
) =>
  (options.client ?? client).post<OrgMemberAddResponses, OrgMemberAddErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a member from an organization
 */
export const orgMemberRemove = <ThrowOnError extends boolean = false>(
  options: Options<OrgMemberRemoveData, ThrowOnError>
) =>
  (options.client ?? client).delete<OrgMemberRemoveResponses, OrgMemberRemoveErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/members/{user_id}",
    ...options,
  });

/**
 * List model pricing for an organization
 */
export const modelPricingListByOrg = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingListByOrgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ModelPricingListByOrgResponses,
    ModelPricingListByOrgErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/model-pricing",
    ...options,
  });

/**
 * List projects in an organization
 */
export const projectList = <ThrowOnError extends boolean = false>(
  options: Options<ProjectListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProjectListResponses, ProjectListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects",
    ...options,
  });

/**
 * Create a project in an organization
 */
export const projectCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProjectCreateResponses, ProjectCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a project
 */
export const projectDelete = <ThrowOnError extends boolean = false>(
  options: Options<ProjectDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProjectDeleteResponses, ProjectDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}",
    ...options,
  });

/**
 * Get a project by slug
 */
export const projectGet = <ThrowOnError extends boolean = false>(
  options: Options<ProjectGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ProjectGetResponses, ProjectGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}",
    ...options,
  });

/**
 * Update a project
 */
export const projectUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<ProjectUpdateResponses, ProjectUpdateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List API keys by project
 */
export const apiKeyListByProject = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyListByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiKeyListByProjectResponses,
    ApiKeyListByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/api-keys",
    ...options,
  });

/**
 * List conversations by project
 */
export const conversationListByProject = <ThrowOnError extends boolean = false>(
  options: Options<ConversationListByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ConversationListByProjectResponses,
    ConversationListByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/conversations",
    ...options,
  });

/**
 * List dynamic providers by project
 */
export const dynamicProviderListByProject = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderListByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DynamicProviderListByProjectResponses,
    DynamicProviderListByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/dynamic-providers",
    ...options,
  });

/**
 * List project members
 */
export const projectMemberList = <ThrowOnError extends boolean = false>(
  options: Options<ProjectMemberListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProjectMemberListResponses, ProjectMemberListErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/members",
      ...options,
    }
  );

/**
 * Add a member to a project
 */
export const projectMemberAdd = <ThrowOnError extends boolean = false>(
  options: Options<ProjectMemberAddData, ThrowOnError>
) =>
  (options.client ?? client).post<ProjectMemberAddResponses, ProjectMemberAddErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a member from a project
 */
export const projectMemberRemove = <ThrowOnError extends boolean = false>(
  options: Options<ProjectMemberRemoveData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProjectMemberRemoveResponses,
    ProjectMemberRemoveErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/members/{user_id}",
    ...options,
  });

/**
 * List model pricing for a project
 */
export const modelPricingListByProject = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingListByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ModelPricingListByProjectResponses,
    ModelPricingListByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/model-pricing",
    ...options,
  });

/**
 * List templates by project
 */
export const templateListByProject = <ThrowOnError extends boolean = false>(
  options: Options<TemplateListByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateListByProjectResponses,
    TemplateListByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/templates",
    ...options,
  });

/**
 * Get usage summary for a project
 */
export const usageGetProjectSummary = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectSummaryResponses,
    UsageGetProjectSummaryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage",
    ...options,
  });

/**
 * Get usage by date for a project
 */
export const usageGetProjectByDate = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByDateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectByDateResponses,
    UsageGetProjectByDateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-date",
    ...options,
  });

/**
 * Get usage by date and model for a project
 */
export const usageGetProjectByDateModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByDateModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProjectByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-date-model",
    ...options,
  });

/**
 * Get usage by date and pricing source for a project
 */
export const usageGetProjectByDatePricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByDatePricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectByDatePricingSourceResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get usage by date and provider for a project
 */
export const usageGetProjectByDateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByDateProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProjectByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-date-provider",
    ...options,
  });

/**
 * Get usage by date and user for a project
 */
export const usageGetProjectByDateUser = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByDateUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectByDateUserResponses,
    UsageGetProjectByDateUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-date-user",
    ...options,
  });

/**
 * Get usage by model for a project
 */
export const usageGetProjectByModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByModelData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectByModelResponses,
    UsageGetProjectByModelErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-model",
    ...options,
  });

/**
 * Get usage by pricing source for a project
 */
export const usageGetProjectByPricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByPricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProjectByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-pricing-source",
    ...options,
  });

/**
 * Get usage by provider for a project
 */
export const usageGetProjectByProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectByProviderResponses,
    UsageGetProjectByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-provider",
    ...options,
  });

/**
 * Get usage by user for a project
 */
export const usageGetProjectByUser = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectByUserResponses,
    UsageGetProjectByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/by-user",
    ...options,
  });

/**
 * Get cost forecast for a project
 *
 * Uses historical usage data across all API keys in the project to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetProjectForecast = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProjectForecastData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetProjectForecastResponses,
    UsageGetProjectForecastErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/projects/{project_slug}/usage/forecast",
    ...options,
  });

/**
 * List RBAC policies for an organization
 */
export const orgRbacPolicyList = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyListData, ThrowOnError>
) =>
  (options.client ?? client).get<OrgRbacPolicyListResponses, OrgRbacPolicyListErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{org_slug}/rbac-policies",
      ...options,
    }
  );

/**
 * Create a new RBAC policy for an organization
 */
export const orgRbacPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgRbacPolicyCreateResponses,
    OrgRbacPolicyCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Simulate policy evaluation for an organization
 *
 * Tests what decision would be made for a given subject and context.
 * Evaluates both system policies (from config) and organization policies (from database),
 * matching the runtime authorization flow.
 *
 * ## Evaluation Order
 *
 * 1. Check if RBAC is disabled → return allow with `rbac_enabled: false`
 * 2. Evaluate system policies (from config file) first
 * 3. If a system policy matches → return that decision
 * 4. Evaluate organization policies (from database)
 * 5. If an org policy matches → return that decision
 * 6. No policy matched → apply configured `default_effect`
 */
export const orgRbacPolicySimulate = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicySimulateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgRbacPolicySimulateResponses,
    OrgRbacPolicySimulateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies/simulate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an RBAC policy
 */
export const orgRbacPolicyDelete = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    OrgRbacPolicyDeleteResponses,
    OrgRbacPolicyDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies/{policy_id}",
    ...options,
  });

/**
 * Get an RBAC policy by ID
 */
export const orgRbacPolicyGet = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyGetData, ThrowOnError>
) =>
  (options.client ?? client).get<OrgRbacPolicyGetResponses, OrgRbacPolicyGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies/{policy_id}",
    ...options,
  });

/**
 * Update an RBAC policy
 */
export const orgRbacPolicyUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    OrgRbacPolicyUpdateResponses,
    OrgRbacPolicyUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies/{policy_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Rollback an RBAC policy to a previous version
 */
export const orgRbacPolicyRollback = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyRollbackData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgRbacPolicyRollbackResponses,
    OrgRbacPolicyRollbackErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies/{policy_id}/rollback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List version history for an RBAC policy
 */
export const orgRbacPolicyListVersions = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyListVersionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OrgRbacPolicyListVersionsResponses,
    OrgRbacPolicyListVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/rbac-policies/{policy_id}/versions",
    ...options,
  });

/**
 * Delete the SCIM configuration for an organization
 */
export const orgScimConfigDelete = <ThrowOnError extends boolean = false>(
  options: Options<OrgScimConfigDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    OrgScimConfigDeleteResponses,
    OrgScimConfigDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/scim-config",
    ...options,
  });

/**
 * Get the SCIM configuration for an organization
 */
export const orgScimConfigGet = <ThrowOnError extends boolean = false>(
  options: Options<OrgScimConfigGetData, ThrowOnError>
) =>
  (options.client ?? client).get<OrgScimConfigGetResponses, OrgScimConfigGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/scim-config",
    ...options,
  });

/**
 * Update the SCIM configuration for an organization
 */
export const orgScimConfigUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrgScimConfigUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    OrgScimConfigUpdateResponses,
    OrgScimConfigUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/scim-config",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a new SCIM configuration for an organization
 *
 * Each organization can have at most one SCIM configuration. Creating a config
 * for an organization that already has one will result in a 409 Conflict error.
 *
 * The response includes the SCIM bearer token which is only shown once.
 * Store it securely - it cannot be retrieved again.
 */
export const orgScimConfigCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrgScimConfigCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgScimConfigCreateResponses,
    OrgScimConfigCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/scim-config",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Rotate the SCIM bearer token for an organization
 *
 * Generates a new bearer token and invalidates the old one immediately.
 * The new token is returned only once - store it securely.
 */
export const orgScimConfigRotateToken = <ThrowOnError extends boolean = false>(
  options: Options<OrgScimConfigRotateTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgScimConfigRotateTokenResponses,
    OrgScimConfigRotateTokenErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/scim-config/rotate-token",
    ...options,
  });

/**
 * List service accounts in an organization
 */
export const serviceAccountList = <ThrowOnError extends boolean = false>(
  options: Options<ServiceAccountListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ServiceAccountListResponses,
    ServiceAccountListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/service-accounts",
    ...options,
  });

/**
 * Create a service account in an organization
 */
export const serviceAccountCreate = <ThrowOnError extends boolean = false>(
  options: Options<ServiceAccountCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ServiceAccountCreateResponses,
    ServiceAccountCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/service-accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a service account
 */
export const serviceAccountDelete = <ThrowOnError extends boolean = false>(
  options: Options<ServiceAccountDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ServiceAccountDeleteResponses,
    ServiceAccountDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/service-accounts/{sa_slug}",
    ...options,
  });

/**
 * Get a service account by slug
 */
export const serviceAccountGet = <ThrowOnError extends boolean = false>(
  options: Options<ServiceAccountGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ServiceAccountGetResponses, ServiceAccountGetErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{org_slug}/service-accounts/{sa_slug}",
      ...options,
    }
  );

/**
 * Update a service account
 */
export const serviceAccountUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ServiceAccountUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ServiceAccountUpdateResponses,
    ServiceAccountUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/service-accounts/{sa_slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List API keys by service account
 */
export const apiKeyListByServiceAccount = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyListByServiceAccountData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiKeyListByServiceAccountResponses,
    ApiKeyListByServiceAccountErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/service-accounts/{sa_slug}/api-keys",
    ...options,
  });

/**
 * Delete the SSO configuration for an organization
 */
export const orgSsoConfigDelete = <ThrowOnError extends boolean = false>(
  options: Options<OrgSsoConfigDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    OrgSsoConfigDeleteResponses,
    OrgSsoConfigDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config",
    ...options,
  });

/**
 * Get the SSO configuration for an organization
 */
export const orgSsoConfigGet = <ThrowOnError extends boolean = false>(
  options: Options<OrgSsoConfigGetData, ThrowOnError>
) =>
  (options.client ?? client).get<OrgSsoConfigGetResponses, OrgSsoConfigGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config",
    ...options,
  });

/**
 * Update the SSO configuration for an organization
 */
export const orgSsoConfigUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrgSsoConfigUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    OrgSsoConfigUpdateResponses,
    OrgSsoConfigUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a new SSO configuration for an organization
 *
 * Each organization can have at most one SSO configuration. Creating a config
 * for an organization that already has one will result in a 409 Conflict error.
 */
export const orgSsoConfigCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrgSsoConfigCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgSsoConfigCreateResponses,
    OrgSsoConfigCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all domain verifications for an organization's SSO config
 */
export const domainVerificationsList = <ThrowOnError extends boolean = false>(
  options: Options<DomainVerificationsListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DomainVerificationsListResponses,
    DomainVerificationsListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/domains",
    ...options,
  });

/**
 * Initiate domain verification for an organization's SSO config
 *
 * Creates a new domain verification record with a unique verification token.
 * Returns the verification instructions with DNS record details.
 */
export const domainVerificationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DomainVerificationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DomainVerificationsCreateResponses,
    DomainVerificationsCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/domains",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a domain verification
 */
export const domainVerificationsDelete = <ThrowOnError extends boolean = false>(
  options: Options<DomainVerificationsDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DomainVerificationsDeleteResponses,
    DomainVerificationsDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/domains/{domain_id}",
    ...options,
  });

/**
 * Get a specific domain verification by ID
 */
export const domainVerificationsGet = <ThrowOnError extends boolean = false>(
  options: Options<DomainVerificationsGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DomainVerificationsGetResponses,
    DomainVerificationsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/domains/{domain_id}",
    ...options,
  });

/**
 * Get verification instructions for a domain
 */
export const domainVerificationsGetInstructions = <ThrowOnError extends boolean = false>(
  options: Options<DomainVerificationsGetInstructionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DomainVerificationsGetInstructionsResponses,
    DomainVerificationsGetInstructionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/domains/{domain_id}/instructions",
    ...options,
  });

/**
 * Trigger DNS verification for a domain
 *
 * Performs a DNS TXT record lookup to verify domain ownership.
 */
export const domainVerificationsVerify = <ThrowOnError extends boolean = false>(
  options: Options<DomainVerificationsVerifyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DomainVerificationsVerifyResponses,
    DomainVerificationsVerifyErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/domains/{domain_id}/verify",
    ...options,
  });

/**
 * Parse SAML IdP metadata from a URL
 *
 * Fetches IdP metadata from the provided URL and extracts configuration fields.
 * This does NOT save the configuration - it returns the parsed data for admin review.
 * Use the returned values to populate the SSO config fields.
 */
export const orgSsoConfigParseSamlMetadata = <ThrowOnError extends boolean = false>(
  options: Options<OrgSsoConfigParseSamlMetadataData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgSsoConfigParseSamlMetadataResponses,
    OrgSsoConfigParseSamlMetadataErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/saml/parse-metadata",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get SP metadata for IdP configuration
 *
 * Returns Hadrian's Service Provider metadata XML that can be imported into
 * the IdP to configure the SAML integration automatically. The metadata includes
 * the SP entity ID, Assertion Consumer Service URL, and supported bindings.
 *
 * This endpoint requires an existing SAML SSO configuration for the organization.
 */
export const orgSsoConfigGetSpMetadata = <ThrowOnError extends boolean = false>(
  options: Options<OrgSsoConfigGetSpMetadataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OrgSsoConfigGetSpMetadataResponses,
    OrgSsoConfigGetSpMetadataErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-config/saml/sp-metadata",
    ...options,
  });

/**
 * List SSO group mappings for an organization
 */
export const ssoGroupMappingList = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SsoGroupMappingListResponses,
    SsoGroupMappingListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings",
    ...options,
  });

/**
 * Create a new SSO group mapping
 */
export const ssoGroupMappingCreate = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SsoGroupMappingCreateResponses,
    SsoGroupMappingCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Export SSO group mappings
 *
 * Exports all SSO group mappings for an organization in JSON or CSV format.
 * Useful for backup, migration, or bulk editing in a spreadsheet.
 */
export const ssoGroupMappingExport = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingExportData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SsoGroupMappingExportResponses,
    SsoGroupMappingExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings/export",
    ...options,
  });

/**
 * Import SSO group mappings
 *
 * Bulk import SSO group mappings from a JSON payload. Useful for migrating
 * mappings between environments or restoring from a backup.
 */
export const ssoGroupMappingImport = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingImportData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SsoGroupMappingImportResponses,
    SsoGroupMappingImportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings/import",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test SSO group mapping resolution
 *
 * Given a list of IdP group names, returns what teams/roles a user with those
 * groups would be resolved to. This is useful for debugging and verifying
 * mapping configuration.
 */
export const ssoGroupMappingTest = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingTestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SsoGroupMappingTestResponses,
    SsoGroupMappingTestErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an SSO group mapping
 */
export const ssoGroupMappingDelete = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    SsoGroupMappingDeleteResponses,
    SsoGroupMappingDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings/{mapping_id}",
    ...options,
  });

/**
 * Get an SSO group mapping by ID
 */
export const ssoGroupMappingGet = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SsoGroupMappingGetResponses,
    SsoGroupMappingGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings/{mapping_id}",
    ...options,
  });

/**
 * Update an SSO group mapping
 */
export const ssoGroupMappingUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SsoGroupMappingUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    SsoGroupMappingUpdateResponses,
    SsoGroupMappingUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/sso-group-mappings/{mapping_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List teams in an organization
 */
export const teamList = <ThrowOnError extends boolean = false>(
  options: Options<TeamListData, ThrowOnError>
) =>
  (options.client ?? client).get<TeamListResponses, TeamListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams",
    ...options,
  });

/**
 * Create a team in an organization
 */
export const teamCreate = <ThrowOnError extends boolean = false>(
  options: Options<TeamCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TeamCreateResponses, TeamCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a team
 */
export const teamDelete = <ThrowOnError extends boolean = false>(
  options: Options<TeamDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<TeamDeleteResponses, TeamDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}",
    ...options,
  });

/**
 * Get a team by slug
 */
export const teamGet = <ThrowOnError extends boolean = false>(
  options: Options<TeamGetData, ThrowOnError>
) =>
  (options.client ?? client).get<TeamGetResponses, TeamGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}",
    ...options,
  });

/**
 * Update a team
 */
export const teamUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TeamUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TeamUpdateResponses, TeamUpdateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List team members
 */
export const teamMemberList = <ThrowOnError extends boolean = false>(
  options: Options<TeamMemberListData, ThrowOnError>
) =>
  (options.client ?? client).get<TeamMemberListResponses, TeamMemberListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/members",
    ...options,
  });

/**
 * Add a member to a team
 */
export const teamMemberAdd = <ThrowOnError extends boolean = false>(
  options: Options<TeamMemberAddData, ThrowOnError>
) =>
  (options.client ?? client).post<TeamMemberAddResponses, TeamMemberAddErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a member from a team
 */
export const teamMemberRemove = <ThrowOnError extends boolean = false>(
  options: Options<TeamMemberRemoveData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    TeamMemberRemoveResponses,
    TeamMemberRemoveErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/members/{user_id}",
    ...options,
  });

/**
 * Update a team member's role
 */
export const teamMemberUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TeamMemberUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TeamMemberUpdateResponses, TeamMemberUpdateErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/members/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );

/**
 * List templates by team
 */
export const templateListByTeam = <ThrowOnError extends boolean = false>(
  options: Options<TemplateListByTeamData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateListByTeamResponses,
    TemplateListByTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/templates",
    ...options,
  });

/**
 * Get usage summary for a team
 */
export const usageGetTeamSummary = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamSummaryResponses,
    UsageGetTeamSummaryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage",
    ...options,
  });

/**
 * Get usage by date for a team
 */
export const usageGetTeamByDate = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByDateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByDateResponses,
    UsageGetTeamByDateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-date",
    ...options,
  });

/**
 * Get usage by date and model for a team
 */
export const usageGetTeamByDateModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByDateModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetTeamByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-date-model",
    ...options,
  });

/**
 * Get usage by date and pricing source for a team
 */
export const usageGetTeamByDatePricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByDatePricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetTeamByDatePricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get usage by date and project for a team
 */
export const usageGetTeamByDateProject = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByDateProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByDateProjectResponses,
    UsageGetTeamByDateProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-date-project",
    ...options,
  });

/**
 * Get usage by date and provider for a team
 */
export const usageGetTeamByDateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByDateProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetTeamByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-date-provider",
    ...options,
  });

/**
 * Get usage by date and user for a team
 */
export const usageGetTeamByDateUser = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByDateUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByDateUserResponses,
    UsageGetTeamByDateUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-date-user",
    ...options,
  });

/**
 * Get usage by model for a team
 */
export const usageGetTeamByModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByModelData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByModelResponses,
    UsageGetTeamByModelErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-model",
    ...options,
  });

/**
 * Get usage by pricing source for a team
 */
export const usageGetTeamByPricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByPricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetTeamByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-pricing-source",
    ...options,
  });

/**
 * Get usage by project for a team
 */
export const usageGetTeamByProject = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByProjectResponses,
    UsageGetTeamByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-project",
    ...options,
  });

/**
 * Get usage by provider for a team
 */
export const usageGetTeamByProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByProviderResponses,
    UsageGetTeamByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-provider",
    ...options,
  });

/**
 * Get usage by user for a team
 */
export const usageGetTeamByUser = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamByUserResponses,
    UsageGetTeamByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/by-user",
    ...options,
  });

/**
 * Get cost forecast for a team
 */
export const usageGetTeamForecast = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetTeamForecastData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetTeamForecastResponses,
    UsageGetTeamForecastErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{org_slug}/teams/{team_slug}/usage/forecast",
    ...options,
  });

/**
 * List templates by organization
 */
export const templateListByOrg = <ThrowOnError extends boolean = false>(
  options: Options<TemplateListByOrgData, ThrowOnError>
) =>
  (options.client ?? client).get<TemplateListByOrgResponses, TemplateListByOrgErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{org_slug}/templates",
      ...options,
    }
  );

/**
 * Delete an organization
 */
export const organizationDelete = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    OrganizationDeleteResponses,
    OrganizationDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}",
    ...options,
  });

/**
 * Get an organization by slug
 */
export const organizationGet = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationGetData, ThrowOnError>
) =>
  (options.client ?? client).get<OrganizationGetResponses, OrganizationGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}",
    ...options,
  });

/**
 * Update an organization
 */
export const organizationUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    OrganizationUpdateResponses,
    OrganizationUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get usage summary for an organization
 */
export const usageGetOrgSummary = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgSummaryResponses,
    UsageGetOrgSummaryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage",
    ...options,
  });

/**
 * Get usage by date for an organization
 */
export const usageGetOrgByDate = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDateData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByDateResponses, UsageGetOrgByDateErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{slug}/usage/by-date",
      ...options,
    }
  );

/**
 * Get usage by date and model for an organization
 */
export const usageGetOrgByDateModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDateModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-date-model",
    ...options,
  });

/**
 * Get usage by date and pricing source for an organization
 */
export const usageGetOrgByDatePricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDatePricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByDatePricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get usage by date and project for an organization
 */
export const usageGetOrgByDateProject = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDateProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgByDateProjectResponses,
    UsageGetOrgByDateProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-date-project",
    ...options,
  });

/**
 * Get usage by date and provider for an organization
 */
export const usageGetOrgByDateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDateProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-date-provider",
    ...options,
  });

/**
 * Get usage by date and team for an organization
 */
export const usageGetOrgByDateTeam = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDateTeamData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgByDateTeamResponses,
    UsageGetOrgByDateTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-date-team",
    ...options,
  });

/**
 * Get usage by date and user for an organization
 */
export const usageGetOrgByDateUser = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByDateUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgByDateUserResponses,
    UsageGetOrgByDateUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-date-user",
    ...options,
  });

/**
 * Get usage by model for an organization
 */
export const usageGetOrgByModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByModelData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgByModelResponses,
    UsageGetOrgByModelErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-model",
    ...options,
  });

/**
 * Get usage by pricing source for an organization
 */
export const usageGetOrgByPricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByPricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-pricing-source",
    ...options,
  });

/**
 * Get usage by project for an organization
 */
export const usageGetOrgByProject = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgByProjectResponses,
    UsageGetOrgByProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-project",
    ...options,
  });

/**
 * Get usage by provider for an organization
 */
export const usageGetOrgByProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgByProviderResponses,
    UsageGetOrgByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/by-provider",
    ...options,
  });

/**
 * Get usage by team for an organization
 */
export const usageGetOrgByTeam = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByTeamData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByTeamResponses, UsageGetOrgByTeamErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{slug}/usage/by-team",
      ...options,
    }
  );

/**
 * Get usage by user for an organization
 */
export const usageGetOrgByUser = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetOrgByUserResponses, UsageGetOrgByUserErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/organizations/{slug}/usage/by-user",
      ...options,
    }
  );

/**
 * Get cost forecast for an organization
 *
 * Uses historical usage data across all API keys in the organization to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetOrgForecast = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetOrgForecastData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetOrgForecastResponses,
    UsageGetOrgForecastErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/organizations/{slug}/usage/forecast",
    ...options,
  });

/**
 * Get circuit breaker status for all providers.
 *
 * Returns the current state and failure count for all configured
 * circuit breakers. Useful for monitoring provider health.
 */
export const listCircuitBreakers = <ThrowOnError extends boolean = false>(
  options?: Options<ListCircuitBreakersData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListCircuitBreakersResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/circuit-breakers",
    ...options,
  });

/**
 * Get health status for all providers.
 *
 * Returns the current health status for all providers that have health checks
 * enabled. Includes status, latency, last check time, and consecutive
 * success/failure counts.
 *
 * Note: Only providers with `health_check.enabled = true` in their config
 * will appear in this list. Providers without health checks rely solely
 * on circuit breaker status.
 */
export const listProviderHealth = <ThrowOnError extends boolean = false>(
  options?: Options<ListProviderHealthData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListProviderHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/health",
    ...options,
  });

/**
 * Get aggregated statistics for all providers.
 *
 * Returns current metrics including latency percentiles, error counts,
 * token usage, and costs for all providers.
 *
 * In single-node deployments, stats are derived from the local /metrics endpoint.
 * In multi-node deployments with Prometheus configured, stats are aggregated
 * from Prometheus queries.
 */
export const listProviderStats = <ThrowOnError extends boolean = false>(
  options?: Options<ListProviderStatsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListProviderStatsResponses,
    ListProviderStatsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/stats",
    ...options,
  });

/**
 * Get circuit breaker status for a specific provider.
 *
 * Returns the current state and failure count for the specified provider's
 * circuit breaker.
 */
export const getCircuitBreaker = <ThrowOnError extends boolean = false>(
  options: Options<GetCircuitBreakerData, ThrowOnError>
) =>
  (options.client ?? client).get<GetCircuitBreakerResponses, GetCircuitBreakerErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/providers/{provider_name}/circuit-breaker",
      ...options,
    }
  );

/**
 * Get health status for a specific provider.
 *
 * Returns the current health status for the specified provider. Only works
 * for providers that have health checks enabled.
 */
export const getProviderHealth = <ThrowOnError extends boolean = false>(
  options: Options<GetProviderHealthData, ThrowOnError>
) =>
  (options.client ?? client).get<GetProviderHealthResponses, GetProviderHealthErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/providers/{provider_name}/health",
      ...options,
    }
  );

/**
 * Get aggregated statistics for a specific provider.
 *
 * Returns current metrics including latency percentiles, error counts,
 * token usage, and costs for the specified provider.
 */
export const getProviderStats = <ThrowOnError extends boolean = false>(
  options: Options<GetProviderStatsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetProviderStatsResponses, GetProviderStatsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/{provider_name}/stats",
    ...options,
  });

/**
 * Get historical statistics for a specific provider.
 *
 * Returns time series data for the specified provider within the given
 * time range. Data is returned as hourly or daily buckets depending
 * on the granularity parameter.
 *
 * **Note:** Historical stats require Prometheus to be configured via
 * `observability.metrics.prometheus_query_url`. In single-node deployments
 * without Prometheus, this endpoint returns an error.
 */
export const getProviderStatsHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetProviderStatsHistoryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProviderStatsHistoryResponses,
    GetProviderStatsHistoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/{provider_name}/stats/history",
    ...options,
  });

/**
 * Get usage summary for a provider
 */
export const usageGetProviderSummary = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProviderSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProviderSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/{provider}/usage",
    ...options,
  });

/**
 * Get usage by date for a provider
 */
export const usageGetProviderByDate = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProviderByDateData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProviderByDateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/{provider}/usage/by-date",
    ...options,
  });

/**
 * Get usage by model for a provider
 */
export const usageGetProviderByModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProviderByModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProviderByModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/{provider}/usage/by-model",
    ...options,
  });

/**
 * Get cost forecast for a provider
 *
 * Uses historical usage data across all API keys using this provider to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetProviderForecast = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetProviderForecastData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetProviderForecastResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/providers/{provider}/usage/forecast",
    ...options,
  });

/**
 * Validate a CEL expression
 *
 * Checks if a CEL expression is syntactically valid without creating a policy.
 * Useful for validating expressions before saving.
 */
export const orgRbacPolicyValidate = <ThrowOnError extends boolean = false>(
  options: Options<OrgRbacPolicyValidateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    OrgRbacPolicyValidateResponses,
    OrgRbacPolicyValidateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/rbac-policies/validate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get comprehensive session and access information.
 *
 * Returns detailed information about the current user's authentication state,
 * database profile, organization/team/project memberships, and SSO configuration.
 * Useful for debugging authentication and authorization issues.
 */
export const sessionInfoGet = <ThrowOnError extends boolean = false>(
  options?: Options<SessionInfoGetData, ThrowOnError>
) =>
  (options?.client ?? client).get<SessionInfoGetResponses, SessionInfoGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/session-info",
    ...options,
  });

/**
 * List configured SSO connections
 *
 * Returns read-only information about SSO connections configured in the gateway.
 * SSO connections are defined in the config file (hadrian.toml), not the database.
 * Currently only one OIDC connection is supported per deployment.
 */
export const ssoConnectionsList = <ThrowOnError extends boolean = false>(
  options?: Options<SsoConnectionsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    SsoConnectionsListResponses,
    SsoConnectionsListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/sso-connections",
    ...options,
  });

/**
 * Get a specific SSO connection by name
 */
export const ssoConnectionGet = <ThrowOnError extends boolean = false>(
  options: Options<SsoConnectionGetData, ThrowOnError>
) =>
  (options.client ?? client).get<SsoConnectionGetResponses, SsoConnectionGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/sso-connections/{name}",
    ...options,
  });

/**
 * Create a template
 */
export const templateCreate = <ThrowOnError extends boolean = false>(
  options: Options<TemplateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TemplateCreateResponses, TemplateCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a template
 */
export const templateDelete = <ThrowOnError extends boolean = false>(
  options: Options<TemplateDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<TemplateDeleteResponses, TemplateDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/templates/{id}",
    ...options,
  });

/**
 * Get a template by ID
 */
export const templateGet = <ThrowOnError extends boolean = false>(
  options: Options<TemplateGetData, ThrowOnError>
) =>
  (options.client ?? client).get<TemplateGetResponses, TemplateGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/templates/{id}",
    ...options,
  });

/**
 * Update a template
 */
export const templateUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TemplateUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TemplateUpdateResponses, TemplateUpdateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get global usage summary
 */
export const usageGetGlobalSummary = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalSummaryData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage",
    ...options,
  });

/**
 * Get global usage by date
 */
export const usageGetGlobalByDate = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date",
    ...options,
  });

/**
 * Get global usage by date and model
 */
export const usageGetGlobalByDateModel = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateModelData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-model",
    ...options,
  });

/**
 * Get global usage by date and organization
 */
export const usageGetGlobalByDateOrg = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateOrgData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateOrgResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-org",
    ...options,
  });

/**
 * Get global usage by date and pricing source
 */
export const usageGetGlobalByDatePricingSource = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDatePricingSourceData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    UsageGetGlobalByDatePricingSourceResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get global usage by date and project
 */
export const usageGetGlobalByDateProject = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateProjectData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateProjectResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-project",
    ...options,
  });

/**
 * Get global usage by date and provider
 */
export const usageGetGlobalByDateProvider = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateProviderData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-provider",
    ...options,
  });

/**
 * Get global usage by date and team
 */
export const usageGetGlobalByDateTeam = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateTeamData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateTeamResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-team",
    ...options,
  });

/**
 * Get global usage by date and user
 */
export const usageGetGlobalByDateUser = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByDateUserData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByDateUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-date-user",
    ...options,
  });

/**
 * Get global usage by model
 */
export const usageGetGlobalByModel = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByModelData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-model",
    ...options,
  });

/**
 * Get global usage by organization
 */
export const usageGetGlobalByOrg = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByOrgData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByOrgResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-org",
    ...options,
  });

/**
 * Get global usage by pricing source
 */
export const usageGetGlobalByPricingSource = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByPricingSourceData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-pricing-source",
    ...options,
  });

/**
 * Get global usage by project
 */
export const usageGetGlobalByProject = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByProjectData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByProjectResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-project",
    ...options,
  });

/**
 * Get global usage by provider
 */
export const usageGetGlobalByProvider = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByProviderData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-provider",
    ...options,
  });

/**
 * Get global usage by team
 */
export const usageGetGlobalByTeam = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByTeamData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByTeamResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-team",
    ...options,
  });

/**
 * Get global usage by user
 */
export const usageGetGlobalByUser = <ThrowOnError extends boolean = false>(
  options?: Options<UsageGetGlobalByUserData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageGetGlobalByUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/by-user",
    ...options,
  });

/**
 * List usage logs (admin global)
 */
export const usageLogList = <ThrowOnError extends boolean = false>(
  options?: Options<UsageLogListData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageLogListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/logs",
    ...options,
  });

/**
 * Export usage logs (admin global)
 */
export const usageLogExport = <ThrowOnError extends boolean = false>(
  options?: Options<UsageLogExportData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsageLogExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/usage/logs/export",
    ...options,
  });

/**
 * List all users
 */
export const userList = <ThrowOnError extends boolean = false>(
  options?: Options<UserListData, ThrowOnError>
) =>
  (options?.client ?? client).get<UserListResponses, UserListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users",
    ...options,
  });

/**
 * Create a user
 */
export const userCreate = <ThrowOnError extends boolean = false>(
  options: Options<UserCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<UserCreateResponses, UserCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a user and all associated data (GDPR Article 17 - Right to Erasure)
 *
 * Permanently deletes the user and all associated data including:
 * - User record
 * - Organization and project memberships
 * - API keys owned by the user
 * - Conversations owned by the user
 * - Dynamic providers owned by the user
 * - Usage records for user's API keys
 *
 * This operation is irreversible.
 */
export const userDelete = <ThrowOnError extends boolean = false>(
  options: Options<UserDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<UserDeleteResponses, UserDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}",
    ...options,
  });

/**
 * Get a user by ID
 */
export const userGet = <ThrowOnError extends boolean = false>(
  options: Options<UserGetData, ThrowOnError>
) =>
  (options.client ?? client).get<UserGetResponses, UserGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}",
    ...options,
  });

/**
 * Update a user
 */
export const userUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UserUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<UserUpdateResponses, UserUpdateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get access summary for a specific user
 *
 * Returns a comprehensive access summary for the specified user including:
 * - All organizations the user belongs to with roles and grant dates
 * - All projects the user belongs to with roles and grant dates
 * - All API keys owned by the user
 * - Last activity timestamps per resource
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const userAccessSummary = <ThrowOnError extends boolean = false>(
  options: Options<UserAccessSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<UserAccessSummaryResponses, UserAccessSummaryErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/v1/users/{user_id}/access-summary",
      ...options,
    }
  );

/**
 * List API keys by user
 */
export const apiKeyListByUser = <ThrowOnError extends boolean = false>(
  options: Options<ApiKeyListByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<ApiKeyListByUserResponses, ApiKeyListByUserErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/api-keys",
    ...options,
  });

/**
 * List conversations by user
 */
export const conversationListByUser = <ThrowOnError extends boolean = false>(
  options: Options<ConversationListByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ConversationListByUserResponses,
    ConversationListByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/conversations",
    ...options,
  });

/**
 * List all conversations accessible to a user
 *
 * Returns both user's personal conversations and conversations from projects they belong to.
 * Results include project metadata when applicable.
 */
export const conversationListAccessibleForUser = <ThrowOnError extends boolean = false>(
  options: Options<ConversationListAccessibleForUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ConversationListAccessibleForUserResponses,
    ConversationListAccessibleForUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/conversations/accessible",
    ...options,
  });

/**
 * List dynamic providers by user
 */
export const dynamicProviderListByUser = <ThrowOnError extends boolean = false>(
  options: Options<DynamicProviderListByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DynamicProviderListByUserResponses,
    DynamicProviderListByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/dynamic-providers",
    ...options,
  });

/**
 * Export all user data (GDPR Article 15 - Right of Access)
 *
 * Returns all personal data associated with the user including:
 * - User profile
 * - Organization and project memberships
 * - API keys (excluding sensitive hash)
 * - Conversations
 * - Usage summary
 * - Audit logs where user was the actor
 */
export const userExport = <ThrowOnError extends boolean = false>(
  options: Options<UserExportData, ThrowOnError>
) =>
  (options.client ?? client).get<UserExportResponses, UserExportErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/export",
    ...options,
  });

/**
 * List model pricing for a user
 */
export const modelPricingListByUser = <ThrowOnError extends boolean = false>(
  options: Options<ModelPricingListByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ModelPricingListByUserResponses,
    ModelPricingListByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/model-pricing",
    ...options,
  });

/**
 * Revoke all sessions for a user (force logout).
 *
 * This is the critical endpoint for the "terminated employee" use case.
 * Returns 0 sessions revoked if enhanced session management is not enabled.
 */
export const userSessionsDeleteAll = <ThrowOnError extends boolean = false>(
  options: Options<UserSessionsDeleteAllData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    UserSessionsDeleteAllResponses,
    UserSessionsDeleteAllErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/sessions",
    ...options,
  });

/**
 * List all active sessions for a user.
 *
 * Returns an empty list if enhanced session management is not enabled.
 * The `enhanced_enabled` field indicates whether session tracking is active.
 */
export const userSessionsList = <ThrowOnError extends boolean = false>(
  options: Options<UserSessionsListData, ThrowOnError>
) =>
  (options.client ?? client).get<UserSessionsListResponses, UserSessionsListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/sessions",
    ...options,
  });

/**
 * Revoke a specific session for a user.
 *
 * Returns success even if the session doesn't exist (idempotent).
 */
export const userSessionsDeleteOne = <ThrowOnError extends boolean = false>(
  options: Options<UserSessionsDeleteOneData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    UserSessionsDeleteOneResponses,
    UserSessionsDeleteOneErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/sessions/{session_id}",
    ...options,
  });

/**
 * List templates by user
 */
export const templateListByUser = <ThrowOnError extends boolean = false>(
  options: Options<TemplateListByUserData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateListByUserResponses,
    TemplateListByUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/templates",
    ...options,
  });

/**
 * Get usage summary for a user
 */
export const usageGetUserSummary = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetUserSummaryResponses,
    UsageGetUserSummaryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage",
    ...options,
  });

/**
 * Get usage by date for a user
 */
export const usageGetUserByDate = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByDateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetUserByDateResponses,
    UsageGetUserByDateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-date",
    ...options,
  });

/**
 * Get usage by date and model for a user
 */
export const usageGetUserByDateModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByDateModelData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetUserByDateModelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-date-model",
    ...options,
  });

/**
 * Get usage by date and pricing source for a user
 */
export const usageGetUserByDatePricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByDatePricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetUserByDatePricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-date-pricing-source",
    ...options,
  });

/**
 * Get usage by date and provider for a user
 */
export const usageGetUserByDateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByDateProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetUserByDateProviderResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-date-provider",
    ...options,
  });

/**
 * Get usage by model for a user
 */
export const usageGetUserByModel = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByModelData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetUserByModelResponses,
    UsageGetUserByModelErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-model",
    ...options,
  });

/**
 * Get usage by pricing source for a user
 */
export const usageGetUserByPricingSource = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByPricingSourceData, ThrowOnError>
) =>
  (options.client ?? client).get<UsageGetUserByPricingSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-pricing-source",
    ...options,
  });

/**
 * Get usage by provider for a user
 */
export const usageGetUserByProvider = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserByProviderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetUserByProviderResponses,
    UsageGetUserByProviderErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/by-provider",
    ...options,
  });

/**
 * Get cost forecast for a user
 *
 * Uses historical usage data across all API keys owned by the user to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetUserForecast = <ThrowOnError extends boolean = false>(
  options: Options<UsageGetUserForecastData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UsageGetUserForecastResponses,
    UsageGetUserForecastErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/v1/users/{user_id}/usage/forecast",
    ...options,
  });

/**
 * Generate speech from text
 *
 * POST /v1/audio/speech
 */
export const apiV1AudioSpeech = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1AudioSpeechData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1AudioSpeechResponses, ApiV1AudioSpeechErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/audio/speech",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Transcribe audio to text
 *
 * POST /v1/audio/transcriptions
 */
export const apiV1AudioTranscriptions = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1AudioTranscriptionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1AudioTranscriptionsResponses,
    ApiV1AudioTranscriptionsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/audio/transcriptions",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Translate audio to English text
 *
 * POST /v1/audio/translations
 */
export const apiV1AudioTranslations = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1AudioTranslationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1AudioTranslationsResponses,
    ApiV1AudioTranslationsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/audio/translations",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Create a chat completion
 *
 * Creates a model response for the given chat conversation. Supports both streaming and
 * non-streaming responses. The model can be specified using provider prefixes (e.g.,
 * `openai/gpt-4o`) or with dynamic routing for multi-tenant configurations.
 */
export const apiV1ChatCompletions = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ChatCompletionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ChatCompletionsResponses,
    ApiV1ChatCompletionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/chat/completions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a text completion
 *
 * Creates a completion for the provided prompt and parameters.
 */
export const apiV1Completions = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1CompletionsData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1CompletionsResponses, ApiV1CompletionsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/completions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * `GET /v1/containers` — list containers in the caller's org,
 * newest-first. Matches OpenAI's cursor pagination shape.
 */
export const apiV1ContainersList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1ContainersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiV1ContainersListResponses,
    ApiV1ContainersListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers",
    ...options,
  });

/**
 * `POST /v1/containers` — create an unattached container.
 */
export const apiV1ContainersCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ContainersCreateResponses,
    ApiV1ContainersCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * `DELETE /v1/containers/{container_id}` — soft-delete a container.
 *
 * Sets `status='deleted'` and evicts the matching in-memory session
 * from the registry so the VM is torn down on the next Arc drop.
 * The underlying `container_files` rows cascade-delete with the
 * container row.
 */
export const apiV1ContainersDelete = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiV1ContainersDeleteResponses,
    ApiV1ContainersDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}",
    ...options,
  });

/**
 * `GET /v1/containers/{container_id}` — retrieve a container.
 */
export const apiV1ContainersGet = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiV1ContainersGetResponses,
    ApiV1ContainersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}",
    ...options,
  });

/**
 * `GET /v1/containers/{container_id}/files` — list files.
 */
export const apiV1ContainersListFiles = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiV1ContainersListFilesResponses,
    ApiV1ContainersListFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}/files",
    ...options,
  });

/**
 * `POST /v1/containers/{container_id}/files` — upload a file into a
 * container's `/mnt/data`. Accepts either:
 *
 * - `multipart/form-data` with a `file` part (required) and optional
 * `path` / `content_type` parts — streams bytes directly.
 * - `application/json` with `{file_id: "file_..."}` — copies an
 * existing Files-API upload into the container (same resolver as
 * the `file_ids` array on `POST /v1/containers`).
 *
 * Matches OpenAI's upload contract.
 */
export const apiV1ContainersFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ContainersFileUploadResponses,
    ApiV1ContainersFileUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}/files",
    ...options,
  });

/**
 * `DELETE /v1/containers/{container_id}/files/{file_id}` — remove
 * a file from a container.
 */
export const apiV1ContainersFileDelete = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersFileDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiV1ContainersFileDeleteResponses,
    ApiV1ContainersFileDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}/files/{file_id}",
    ...options,
  });

/**
 * `GET /v1/containers/{container_id}/files/{file_id}` — file metadata.
 */
export const apiV1ContainersFileGet = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersFileGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiV1ContainersFileGetResponses,
    ApiV1ContainersFileGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}/files/{file_id}",
    ...options,
  });

/**
 * `GET /v1/containers/{container_id}/files/{file_id}/content` — raw bytes.
 */
export const apiV1ContainersFileContent = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ContainersFileContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiV1ContainersFileContentResponses,
    ApiV1ContainersFileContentErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/containers/{container_id}/files/{file_id}/content",
    ...options,
  });

/**
 * Create embeddings
 *
 * Creates an embedding vector representing the input text. Embeddings are useful for
 * semantic search, clustering, classification, and similarity comparisons.
 */
export const apiV1Embeddings = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1EmbeddingsData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1EmbeddingsResponses, ApiV1EmbeddingsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/embeddings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List files
 *
 * Returns a list of files owned by the specified owner.
 */
export const fileList = <ThrowOnError extends boolean = false>(
  options: Options<FileListData, ThrowOnError>
) =>
  (options.client ?? client).get<FileListResponses, FileListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/files",
    ...options,
  });

/**
 * Upload a file
 *
 * Uploads a file that can be used with vector stores for RAG.
 * Files are uploaded as multipart/form-data with the following fields:
 * - `file`: The file to upload (required)
 * - `purpose`: The intended purpose of the file (default: "assistants")
 * - `owner_type`: Owner type - "organization", "project", or "user" (required)
 * - `owner_id`: Owner ID (required)
 */
export const fileUpload = <ThrowOnError extends boolean = false>(
  options?: Options<FileUploadData, ThrowOnError>
) =>
  (options?.client ?? client).post<FileUploadResponses, FileUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

/**
 * Delete a file
 *
 * Deletes a file. The file cannot be deleted if it is still referenced by any vector stores.
 */
export const fileDelete = <ThrowOnError extends boolean = false>(
  options: Options<FileDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<FileDeleteResponses, FileDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/files/{file_id}",
    ...options,
  });

/**
 * Get file metadata
 *
 * Returns information about a specific file.
 */
export const fileGet = <ThrowOnError extends boolean = false>(
  options: Options<FileGetData, ThrowOnError>
) =>
  (options.client ?? client).get<FileGetResponses, FileGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/files/{file_id}",
    ...options,
  });

/**
 * Get file content
 *
 * Returns the content of a file.
 */
export const fileGetContent = <ThrowOnError extends boolean = false>(
  options: Options<FileGetContentData, ThrowOnError>
) =>
  (options.client ?? client).get<FileGetContentResponses, FileGetContentErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/files/{file_id}/content",
    ...options,
  });

/**
 * Edit image with text instructions
 *
 * POST /v1/images/edits
 */
export const apiV1ImagesEdits = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ImagesEditsData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1ImagesEditsResponses, ApiV1ImagesEditsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/images/edits",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Create image from text prompt
 *
 * POST /v1/images/generations
 */
export const apiV1ImagesGenerations = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ImagesGenerationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ImagesGenerationsResponses,
    ApiV1ImagesGenerationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/images/generations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create image variations
 *
 * POST /v1/images/variations
 */
export const apiV1ImagesVariations = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ImagesVariationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ImagesVariationsResponses,
    ApiV1ImagesVariationsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/images/variations",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * List available models
 *
 * Lists all models available from all configured providers.
 */
export const apiV1Models = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1ModelsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ApiV1ModelsResponses, ApiV1ModelsErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/models",
    ...options,
  });

/**
 * Create a response
 *
 * Creates a model response using the Responses API format.
 */
export const apiV1Responses = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ResponsesData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1ResponsesResponses, ApiV1ResponsesErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/responses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Compact a context window via the provider's standalone compact
 * endpoint.
 *
 * Stateless passthrough: forwards `model` + `input` (and any other
 * fields the provider accepts) to the upstream `/responses/compact`
 * endpoint and streams the compacted window back. Only OpenAI and
 * Azure OpenAI implement this; routing to any other provider returns
 * 501 with `error_code = "not_supported"`.
 */
export const apiV1ResponsesCompact = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ResponsesCompactData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ResponsesCompactResponses,
    ApiV1ResponsesCompactErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/responses/compact",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * `DELETE /v1/responses/{response_id}` — remove a stored response.
 * Returns the OpenAI-spec deletion confirmation shape.
 */
export const apiV1ResponsesDelete = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ResponsesDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiV1ResponsesDeleteResponses,
    ApiV1ResponsesDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/responses/{response_id}",
    ...options,
  });

/**
 * `GET /v1/responses/{response_id}` — retrieve a stored response.
 *
 * When `?stream=true` is set, returns the persisted event log as an
 * SSE stream (matching OpenAI's retrieve-with-stream behavior). The
 * `starting_after` query parameter resumes replay from a specific
 * sequence number so a client reconnecting after a disconnect picks
 * up exactly where it stopped.
 */
export const apiV1ResponsesGet = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ResponsesGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ApiV1ResponsesGetResponses, ApiV1ResponsesGetErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/responses/{response_id}",
      ...options,
    }
  );

/**
 * `POST /v1/responses/{response_id}/cancel` — cancel an in-progress
 * background response. Per OpenAI's spec, returns 400 if the response
 * is not in background mode. Idempotent for already-terminal rows.
 */
export const apiV1ResponsesCancel = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1ResponsesCancelData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1ResponsesCancelResponses,
    ApiV1ResponsesCancelErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/responses/{response_id}/cancel",
    ...options,
  });

/**
 * List skills for the current project (or a specific owner / accessible set).
 */
export const skillList = <ThrowOnError extends boolean = false>(
  options?: Options<SkillListData, ThrowOnError>
) =>
  (options?.client ?? client).get<SkillListResponses, SkillListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills",
    ...options,
  });

/**
 * Create a new skill (and its first version).
 */
export const skillCreate = <ThrowOnError extends boolean = false>(
  options: Options<SkillCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<SkillCreateResponses, SkillCreateErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a skill.
 */
export const skillDelete = <ThrowOnError extends boolean = false>(
  options: Options<SkillDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<SkillDeleteResponses, SkillDeleteErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}",
    ...options,
  });

/**
 * Get a skill by id.
 */
export const skillGet = <ThrowOnError extends boolean = false>(
  options: Options<SkillGetData, ThrowOnError>
) =>
  (options.client ?? client).get<SkillGetResponses, SkillGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}",
    ...options,
  });

/**
 * Set the default version pointer for a skill.
 */
export const skillSetDefaultVersion = <ThrowOnError extends boolean = false>(
  options: Options<SkillSetDefaultVersionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SkillSetDefaultVersionResponses,
    SkillSetDefaultVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Download the default version of a skill as a zip bundle.
 */
export const skillGetContent = <ThrowOnError extends boolean = false>(
  options: Options<SkillGetContentData, ThrowOnError>
) =>
  (options.client ?? client).get<SkillGetContentResponses, SkillGetContentErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}/content",
    ...options,
  });

/**
 * List a skill's versions.
 */
export const skillListVersions = <ThrowOnError extends boolean = false>(
  options: Options<SkillListVersionsData, ThrowOnError>
) =>
  (options.client ?? client).get<SkillListVersionsResponses, SkillListVersionsErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/skills/{skill_id}/versions",
      ...options,
    }
  );

/**
 * Create a new immutable version of a skill.
 */
export const skillCreateVersion = <ThrowOnError extends boolean = false>(
  options: Options<SkillCreateVersionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SkillCreateVersionResponses,
    SkillCreateVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a skill version.
 */
export const skillDeleteVersion = <ThrowOnError extends boolean = false>(
  options: Options<SkillDeleteVersionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    SkillDeleteVersionResponses,
    SkillDeleteVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}/versions/{version}",
    ...options,
  });

/**
 * Get a specific skill version.
 */
export const skillGetVersion = <ThrowOnError extends boolean = false>(
  options: Options<SkillGetVersionData, ThrowOnError>
) =>
  (options.client ?? client).get<SkillGetVersionResponses, SkillGetVersionErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}/versions/{version}",
    ...options,
  });

/**
 * Download a specific skill version as a zip bundle.
 */
export const skillGetVersionContent = <ThrowOnError extends boolean = false>(
  options: Options<SkillGetVersionContentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SkillGetVersionContentResponses,
    SkillGetVersionContentErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/skills/{skill_id}/versions/{version}/content",
    ...options,
  });

/**
 * Fetch a web page
 *
 * Fetches a URL and returns its content, optionally stripping HTML tags.
 *
 * **Hadrian Extension:** This endpoint is not part of the OpenAI API specification.
 */
export const webFetch = <ThrowOnError extends boolean = false>(
  options: Options<WebFetchData, ThrowOnError>
) =>
  (options.client ?? client).post<WebFetchResponses, WebFetchErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/tools/web-fetch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search the web
 *
 * Performs a web search using the configured search provider (Tavily or Exa).
 *
 * **Hadrian Extension:** This endpoint is not part of the OpenAI API specification.
 */
export const webSearch = <ThrowOnError extends boolean = false>(
  options: Options<WebSearchData, ThrowOnError>
) =>
  (options.client ?? client).post<WebSearchResponses, WebSearchErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/tools/web-search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List vector stores
 *
 * Returns a list of vector stores owned by the specified owner.
 */
export const vectorStoreList = <ThrowOnError extends boolean = false>(
  options?: Options<VectorStoreListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VectorStoreListResponses, VectorStoreListErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores",
    ...options,
  });

/**
 * Create a vector store
 *
 * Creates a new vector store for storing file embeddings.
 * Optionally attaches files to the vector store at creation time via `file_ids`.
 */
export const vectorStoreCreate = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VectorStoreCreateResponses,
    VectorStoreCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a vector store
 *
 * Deletes a vector store and all its files (soft delete).
 */
export const vectorStoreDelete = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VectorStoreDeleteResponses,
    VectorStoreDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}",
    ...options,
  });

/**
 * Get a vector store
 *
 * Retrieves a vector store by ID.
 */
export const vectorStoreGet = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreGetData, ThrowOnError>
) =>
  (options.client ?? client).get<VectorStoreGetResponses, VectorStoreGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}",
    ...options,
  });

/**
 * Modify a vector store
 *
 * Modifies a vector store's metadata.
 */
export const vectorStoreModify = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreModifyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VectorStoreModifyResponses,
    VectorStoreModifyErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a file batch
 *
 * Creates a batch of files to be added to a vector store.
 * Note: File batches are not yet fully implemented. This endpoint creates
 * files individually and returns a batch representation.
 *
 * ## Content Deduplication
 *
 * Files are deduplicated by content hash (SHA-256). If a file with identical content
 * already exists in the vector store, it is counted as "completed" in the batch
 * response but no re-processing occurs. This prevents duplicate chunks and wasted
 * compute while still reporting success for the file.
 *
 * The `file_counts.completed` field in the response includes both newly processed
 * files and deduplicated files.
 *
 * ## Embedding Model Validation
 *
 * The gateway validates that its configured embedding model matches the vector store's
 * embedding model before processing any files in the batch. This prevents incompatible
 * embeddings from being stored together. If there's a mismatch, a 409 Conflict error
 * is returned with details about the expected vs. configured models.
 */
export const vectorStoreFileBatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileBatchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VectorStoreFileBatchCreateResponses,
    VectorStoreFileBatchCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/file_batches",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel a file batch
 *
 * Cancels a file batch. Note: File batches are executed synchronously,
 * so cancellation is not supported.
 */
export const vectorStoreFileBatchCancel = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileBatchCancelData, ThrowOnError>
) =>
  (options.client ?? client).delete<unknown, VectorStoreFileBatchCancelErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/file_batches/{batch_id}",
    ...options,
  });

/**
 * Get a file batch
 *
 * Retrieves a file batch. Note: File batches are executed synchronously,
 * so this endpoint returns a "completed" or "failed" status.
 */
export const vectorStoreFileBatchGet = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileBatchGetData, ThrowOnError>
) =>
  (options.client ?? client).get<unknown, VectorStoreFileBatchGetErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/file_batches/{batch_id}",
    ...options,
  });

/**
 * List files in a batch
 *
 * Lists files in a file batch. Note: File batches are not persisted.
 */
export const vectorStoreFileBatchListFiles = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileBatchListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<unknown, VectorStoreFileBatchListFilesErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/file_batches/{batch_id}/files",
    ...options,
  });

/**
 * List vector store files
 *
 * Returns a list of files in a vector store.
 */
export const vectorStoreFileList = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VectorStoreFileListResponses,
    VectorStoreFileListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/files",
    ...options,
  });

/**
 * Create a vector store file
 *
 * Adds a file to a vector store. The file must already exist in the Files API.
 * Processing will start automatically after the file is added.
 *
 * ## Content Deduplication
 *
 * Files are deduplicated by content hash (SHA-256). If a file with identical content
 * already exists in the vector store, the existing file is returned with status 200
 * instead of creating a duplicate. This is idempotent behavior—uploading the same
 * content multiple times has no additional effect.
 *
 * ## Embedding Model Validation
 *
 * The gateway validates that its configured embedding model matches the vector store's
 * embedding model before adding files. This prevents incompatible embeddings from being
 * stored together. If there's a mismatch, a 409 Conflict error is returned with details
 * about the expected vs. configured models.
 *
 * - **201 Created**: New file added, processing started
 * - **200 OK**: Duplicate content detected, existing file returned (no re-processing)
 * - **409 Conflict**: Embedding model mismatch between gateway configuration and vector store
 */
export const vectorStoreFileCreate = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VectorStoreFileCreateResponses,
    VectorStoreFileCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a vector store file
 *
 * Removes a file from a vector store. This does not delete the underlying file
 * from the Files API.
 */
export const vectorStoreFileDelete = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VectorStoreFileDeleteResponses,
    VectorStoreFileDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/files/{file_id}",
    ...options,
  });

/**
 * Get a vector store file
 *
 * Retrieves a file from a vector store.
 */
export const vectorStoreFileGet = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VectorStoreFileGetResponses,
    VectorStoreFileGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/files/{file_id}",
    ...options,
  });

/**
 * List chunks for a file [Hadrian Extension]
 *
 * **Hadrian Extension** - This endpoint is not part of the standard OpenAI API.
 *
 * Returns all chunks that have been extracted and embedded from a file. Useful for debugging chunking behavior and verifying embeddings.
 */
export const vectorStoreFileChunksList = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreFileChunksListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VectorStoreFileChunksListResponses,
    VectorStoreFileChunksListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/files/{file_id}/chunks",
    ...options,
  });

/**
 * Search vector store
 *
 * Performs a semantic search against a vector store.
 *
 * **Hadrian Extensions:** The response schema includes additional fields not in the standard OpenAI API:
 * - `chunk_id`, `vector_store_id`, `chunk_index` (debugging info)
 */
export const vectorStoreSearch = <ThrowOnError extends boolean = false>(
  options: Options<VectorStoreSearchData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VectorStoreSearchResponses,
    VectorStoreSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/vector_stores/{vector_store_id}/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List video jobs
 *
 * GET /v1/videos
 */
export const apiV1VideosList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1VideosListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ApiV1VideosListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos",
    ...options,
  });

/**
 * Create a video generation job
 *
 * POST /v1/videos
 */
export const apiV1VideosCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiV1VideosCreateResponses,
    ApiV1VideosCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a character from a reference video
 *
 * POST /v1/videos/characters (multipart/form-data: name, video, [model])
 */
export const apiV1VideosCharactersCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosCharactersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1VideosCharactersCreateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/characters",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Retrieve a character
 *
 * GET /v1/videos/characters/{character_id}
 */
export const apiV1VideosCharactersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosCharactersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ApiV1VideosCharactersRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/characters/{character_id}",
    ...options,
  });

/**
 * Edit a video into a new job
 *
 * POST /v1/videos/edits
 */
export const apiV1VideosEdits = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosEditsData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1VideosEditsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/edits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extend a video into a new job
 *
 * POST /v1/videos/extensions
 */
export const apiV1VideosExtensions = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosExtensionsData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1VideosExtensionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/extensions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a video job
 *
 * DELETE /v1/videos/{video_id}
 */
export const apiV1VideosDelete = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<ApiV1VideosDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/{video_id}",
    ...options,
  });

/**
 * Retrieve a video job (refreshes status from the provider)
 *
 * GET /v1/videos/{video_id}
 */
export const apiV1VideosRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiV1VideosRetrieveResponses,
    ApiV1VideosRetrieveErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/{video_id}",
    ...options,
  });

/**
 * Download the rendered asset for a video job
 *
 * GET /v1/videos/{video_id}/content
 */
export const apiV1VideosContent = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosContentData, ThrowOnError>
) =>
  (options.client ?? client).get<ApiV1VideosContentResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/{video_id}/content",
    ...options,
  });

/**
 * Remix a video into a new job
 *
 * POST /v1/videos/{video_id}/remix
 */
export const apiV1VideosRemix = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1VideosRemixData, ThrowOnError>
) =>
  (options.client ?? client).post<ApiV1VideosRemixResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/videos/{video_id}/remix",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Discover SSO configuration for an email address.
 *
 * This endpoint allows the frontend to determine which IdP to use for login
 * based on the user's email domain. If the email domain matches an organization
 * with SSO configured, the response includes the organization details and IdP info.
 *
 * SSO is only available when the email domain has been verified via DNS TXT record.
 * The response includes domain verification status to help users understand why
 * SSO may not be available.
 */
export const authDiscover = <ThrowOnError extends boolean = false>(
  options: Options<AuthDiscoverData, ThrowOnError>
) =>
  (options.client ?? client).get<AuthDiscoverResponses, AuthDiscoverErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/auth/discover",
    ...options,
  });

/**
 * Get current user identity.
 */
export const authMe = <ThrowOnError extends boolean = false>(
  options?: Options<AuthMeData, ThrowOnError>
) =>
  (options?.client ?? client).get<AuthMeResponses, AuthMeErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/auth/me",
    ...options,
  });

/**
 * Full health check with subsystem status.
 *
 * Returns detailed status of all subsystems including database, cache, and secrets manager.
 * Use this endpoint for comprehensive health monitoring and dashboards.
 */
export const healthCheck = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckData, ThrowOnError>
) =>
  (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/health",
    ...options,
  });

/**
 * Kubernetes liveness probe.
 *
 * Returns 200 if the service is running. This endpoint should always succeed
 * unless the service process is completely broken. Use this for Kubernetes
 * liveness probes to detect and restart unhealthy pods.
 */
export const healthLiveness = <ThrowOnError extends boolean = false>(
  options?: Options<HealthLivenessData, ThrowOnError>
) =>
  (options?.client ?? client).get<HealthLivenessResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/health/live",
    ...options,
  });

/**
 * Kubernetes readiness probe.
 *
 * Returns 200 if the service is ready to accept traffic. Checks that critical
 * dependencies (database) are available. Use this for Kubernetes readiness
 * probes to control traffic routing to pods.
 */
export const healthReadiness = <ThrowOnError extends boolean = false>(
  options?: Options<HealthReadinessData, ThrowOnError>
) =>
  (options?.client ?? client).get<HealthReadinessResponses, HealthReadinessErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/health/ready",
    ...options,
  });

/**
 * Exchange a PKCE authorization code for a user-scoped API key.
 */
export const oauthToken = <ThrowOnError extends boolean = false>(
  options: Options<OauthTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<OauthTokenResponses, OauthTokenErrors, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/oauth/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
